import React from 'react'
import Footer from './Footer';
import HeaderLinks from './HeaderLinks';
import NoTabMainHeader from './NoTabMainHeader';
import { Collapse, Button, CardBody, Card } from 'reactstrap';
import $ from 'jquery';
import SubFooter from './SubFooter';
import CommonHeder from './CommonHeder';

class AllTermsOfServices extends React.Component{

  constructor(props) {
    super(props);

    this.state = {

        q1: false,
        b1: true,

        q2: false,
        b2: true,

        q3:false,
        b3:true,
  
        q4:false,
        b4:true,
  
        q5:false,
        b5:true,
  
        q6:false,
        b6:true,
  
        q7:false,
        b7:true,

        q8:false,
        b8:true,

        q9:false,
        b9:true,

        q10:false,
        b10:true,

        q11:false,
        b11:true,

        q12:false,
        b12:true,

        q13:false,
        b13:true,

        q14:false,
        b14:true,

        q15:false,
        b15:true,

        q16:false,
        b16:true,

        q17:false,
        b17:true,

        q18:false,
        b18:true,

        q19:false,
        b19:true,

        q20:false,
        b20:true,

        q21:false,
        b21:true,

        q23:false,
        b23:true,

        q22:false,
        b22:true,

        q24:false,
        b24:true,

        q25:false,
        b25:true,

        q26:false,
        b26:true,

        q27:false,
        b27:true,

        q28:false,
        b28:true,

 

    }
    
    this.toggle1 = this.toggle1.bind(this);
    this.toggle2 = this.toggle2.bind(this);
    this.toggle3 = this.toggle3.bind(this);
    this.toggle4 = this.toggle4.bind(this);
    this.toggle5 = this.toggle5.bind(this);
    this.toggle6 = this.toggle6.bind(this);
    this.toggle7 = this.toggle7.bind(this);
    this.toggle8 = this.toggle8.bind(this);
    this.toggle9 = this.toggle9.bind(this);
    this.toggle10 = this.toggle10.bind(this);
    this.toggle11 = this.toggle11.bind(this);
    this.toggle12 = this.toggle12.bind(this);
    this.toggle13 = this.toggle13.bind(this);
    this.toggle14 = this.toggle14.bind(this);
    this.toggle15 = this.toggle15.bind(this);
    this.toggle16 = this.toggle16.bind(this);
    this.toggle17 = this.toggle17.bind(this);
    this.toggle18 = this.toggle18.bind(this);
    this.toggle19 = this.toggle19.bind(this);
    this.toggle20 = this.toggle20.bind(this);
    this.toggle21 = this.toggle21.bind(this);
    this.toggle22 = this.toggle22.bind(this);
    this.toggle23 = this.toggle23.bind(this);
    this.toggle24 = this.toggle24.bind(this);
    this.toggle25 = this.toggle25.bind(this);
    this.toggle26 = this.toggle26.bind(this);
    this.toggle27 = this.toggle27.bind(this);
    this.toggle28 = this.toggle28.bind(this);
   


}

toggle1() {
  this.setState(state => ({ q1: !state.q1 }));
  this.setState(state => ({ b1: !state.b1 }));

  
  this.setState({q2: false}, function () {});
  this.setState({b2: true}, function () {});
  this.setState({q3: false}, function () {});
  this.setState({b3: true}, function () {});
  this.setState({q4: false}, function () {});
  this.setState({b4: true}, function () {});
  this.setState({q5: false}, function () {});
  this.setState({b5: true}, function () {});
  this.setState({q6: false}, function () {});
  this.setState({b6: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q8: false}, function () {});
  this.setState({b8: true}, function () {});
  this.setState({q9: false}, function () {});
  this.setState({b9: true}, function () {});
  this.setState({q10: false}, function () {});
  this.setState({b10: true}, function () {});
  this.setState({q11: false}, function () {});
  this.setState({b11: true}, function () {});
  this.setState({q12: false}, function () {});
  this.setState({b12: true}, function () {});
  this.setState({q13: false}, function () {});
  this.setState({b13: true}, function () {});
  this.setState({q14: false}, function () {});
  this.setState({b14: true}, function () {});
  this.setState({q15: false}, function () {});
  this.setState({b15: true}, function () {});
  this.setState({q16: false}, function () {});
  this.setState({b16: true}, function () {});
  this.setState({q17: false}, function () {});
  this.setState({b17: true}, function () {});
  this.setState({q18: false}, function () {});
  this.setState({b18: true}, function () {});
  this.setState({q19: false}, function () {});
  this.setState({b19: true}, function () {});
  this.setState({q20: false}, function () {});
  this.setState({b20: true}, function () {});
  this.setState({q21: false}, function () {});
  this.setState({b21: true}, function () {});
  this.setState({q22: false}, function () {});
  this.setState({b22: true}, function () {});
  this.setState({q23: false}, function () {});
  this.setState({b23: true}, function () {});
  this.setState({q24: false}, function () {});
  this.setState({b24: true}, function () {});
  this.setState({q25: false}, function () {});
  this.setState({b25: true}, function () {});
  this.setState({q26: false}, function () {});
  this.setState({b26: true}, function () {});
  this.setState({q27: false}, function () {});
  this.setState({b27: true}, function () {});
  this.setState({q28: false}, function () {});
  this.setState({b28: true}, function () {});


}

toggle2() {
  this.setState(state => ({ q2: !state.q2 }));
  this.setState(state => ({ b2: !state.b2 }));

  this.setState({q1: false}, function () {});
  this.setState({b1: true}, function () {});
  this.setState({q3: false}, function () {});
  this.setState({b3: true}, function () {});
  this.setState({q4: false}, function () {});
  this.setState({b4: true}, function () {});
  this.setState({q5: false}, function () {});
  this.setState({b5: true}, function () {});
  this.setState({q6: false}, function () {});
  this.setState({b6: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q8: false}, function () {});
  this.setState({b8: true}, function () {});
  this.setState({q9: false}, function () {});
  this.setState({b9: true}, function () {});
  this.setState({q10: false}, function () {});
  this.setState({b10: true}, function () {});
  this.setState({q11: false}, function () {});
  this.setState({b11: true}, function () {});
  this.setState({q12: false}, function () {});
  this.setState({b12: true}, function () {});
  this.setState({q13: false}, function () {});
  this.setState({b13: true}, function () {});
  this.setState({q14: false}, function () {});
  this.setState({b14: true}, function () {});
  this.setState({q15: false}, function () {});
  this.setState({b15: true}, function () {});
  this.setState({q16: false}, function () {});
  this.setState({b16: true}, function () {});
  this.setState({q17: false}, function () {});
  this.setState({b17: true}, function () {});
  this.setState({q18: false}, function () {});
  this.setState({b18: true}, function () {});
  this.setState({q19: false}, function () {});
  this.setState({b19: true}, function () {});
  this.setState({q20: false}, function () {});
  this.setState({b20: true}, function () {});
  this.setState({q21: false}, function () {});
  this.setState({b21: true}, function () {});
  this.setState({q22: false}, function () {});
  this.setState({b22: true}, function () {});
  this.setState({q23: false}, function () {});
  this.setState({b23: true}, function () {});
  this.setState({q24: false}, function () {});
  this.setState({b24: true}, function () {});
  this.setState({q25: false}, function () {});
  this.setState({b25: true}, function () {});
  this.setState({q26: false}, function () {});
  this.setState({b26: true}, function () {});
  this.setState({q27: false}, function () {});
  this.setState({b27: true}, function () {});
  this.setState({q28: false}, function () {});
  this.setState({b28: true}, function () {});
}

toggle3() {
  this.setState(state => ({ q3: !state.q3 }));
  this.setState(state => ({ b3: !state.b3 }));

  this.setState({q1: false}, function () {});
  this.setState({b1: true}, function () {});
  this.setState({q2: false}, function () {});
  this.setState({b2: true}, function () {});
  this.setState({q4: false}, function () {});
  this.setState({b4: true}, function () {});
  this.setState({q5: false}, function () {});
  this.setState({b5: true}, function () {});
  this.setState({q6: false}, function () {});
  this.setState({b6: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q8: false}, function () {});
  this.setState({b8: true}, function () {});
  this.setState({q9: false}, function () {});
  this.setState({b9: true}, function () {});
  this.setState({q10: false}, function () {});
  this.setState({b10: true}, function () {});
  this.setState({q11: false}, function () {});
  this.setState({b11: true}, function () {});
  this.setState({q12: false}, function () {});
  this.setState({b12: true}, function () {});
  this.setState({q13: false}, function () {});
  this.setState({b13: true}, function () {});
  this.setState({q14: false}, function () {});
  this.setState({b14: true}, function () {});
  this.setState({q15: false}, function () {});
  this.setState({b15: true}, function () {});
  this.setState({q16: false}, function () {});
  this.setState({b16: true}, function () {});
  this.setState({q17: false}, function () {});
  this.setState({b17: true}, function () {});
  this.setState({q18: false}, function () {});
  this.setState({b18: true}, function () {});
  this.setState({q19: false}, function () {});
  this.setState({b19: true}, function () {});
  this.setState({q20: false}, function () {});
  this.setState({b20: true}, function () {});
  this.setState({q21: false}, function () {});
  this.setState({b21: true}, function () {});
  this.setState({q22: false}, function () {});
  this.setState({b22: true}, function () {});
  this.setState({q23: false}, function () {});
  this.setState({b23: true}, function () {});
  this.setState({q24: false}, function () {});
  this.setState({b24: true}, function () {});
  this.setState({q25: false}, function () {});
  this.setState({b25: true}, function () {});
  this.setState({q26: false}, function () {});
  this.setState({b26: true}, function () {});
  this.setState({q27: false}, function () {});
  this.setState({b27: true}, function () {});
  this.setState({q28: false}, function () {});
  this.setState({b28: true}, function () {});
}

toggle4() {
  this.setState(state => ({ q4: !state.q4 }));
  this.setState(state => ({ b4: !state.b4 }));

  this.setState({q1: false}, function () {});
  this.setState({b1: true}, function () {});
  this.setState({q2: false}, function () {});
  this.setState({b2: true}, function () {});
  this.setState({q3: false}, function () {});
  this.setState({b3: true}, function () {});
  this.setState({q5: false}, function () {});
  this.setState({b5: true}, function () {});
  this.setState({q6: false}, function () {});
  this.setState({b6: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q8: false}, function () {});
  this.setState({b8: true}, function () {});
  this.setState({q9: false}, function () {});
  this.setState({b9: true}, function () {});
  this.setState({q10: false}, function () {});
  this.setState({b10: true}, function () {});
  this.setState({q11: false}, function () {});
  this.setState({b11: true}, function () {});
  this.setState({q12: false}, function () {});
  this.setState({b12: true}, function () {});
  this.setState({q13: false}, function () {});
  this.setState({b13: true}, function () {});
  this.setState({q14: false}, function () {});
  this.setState({b14: true}, function () {});
  this.setState({q15: false}, function () {});
  this.setState({b15: true}, function () {});
  this.setState({q16: false}, function () {});
  this.setState({b16: true}, function () {});
  this.setState({q17: false}, function () {});
  this.setState({b17: true}, function () {});
  this.setState({q18: false}, function () {});
  this.setState({b18: true}, function () {});
  this.setState({q19: false}, function () {});
  this.setState({b19: true}, function () {});
  this.setState({q20: false}, function () {});
  this.setState({b20: true}, function () {});
  this.setState({q21: false}, function () {});
  this.setState({b21: true}, function () {});
  this.setState({q22: false}, function () {});
  this.setState({b22: true}, function () {});
  this.setState({q23: false}, function () {});
  this.setState({b23: true}, function () {});
  this.setState({q24: false}, function () {});
  this.setState({b24: true}, function () {});
  this.setState({q25: false}, function () {});
  this.setState({b25: true}, function () {});
  this.setState({q26: false}, function () {});
  this.setState({b26: true}, function () {});
  this.setState({q27: false}, function () {});
  this.setState({b27: true}, function () {});
  this.setState({q28: false}, function () {});
  this.setState({b28: true}, function () {});
}
toggle5() {
  this.setState(state => ({ q5: !state.q5 }));
  this.setState(state => ({ b5: !state.b5 }));

  this.setState({q1: false}, function () {});
  this.setState({b1: true}, function () {});
  this.setState({q2: false}, function () {});
  this.setState({b2: true}, function () {});
  this.setState({q3: false}, function () {});
  this.setState({b3: true}, function () {});
  this.setState({q4: false}, function () {});
  this.setState({b4: true}, function () {});
  this.setState({q6: false}, function () {});
  this.setState({b6: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q8: false}, function () {});
  this.setState({b8: true}, function () {});
  this.setState({q9: false}, function () {});
  this.setState({b9: true}, function () {});
  this.setState({q10: false}, function () {});
  this.setState({b10: true}, function () {});
  this.setState({q11: false}, function () {});
  this.setState({b11: true}, function () {});
  this.setState({q12: false}, function () {});
  this.setState({b12: true}, function () {});
  this.setState({q13: false}, function () {});
  this.setState({b13: true}, function () {});
  this.setState({q14: false}, function () {});
  this.setState({b14: true}, function () {});
  this.setState({q15: false}, function () {});
  this.setState({b15: true}, function () {});
  this.setState({q16: false}, function () {});
  this.setState({b16: true}, function () {});
  this.setState({q17: false}, function () {});
  this.setState({b17: true}, function () {});
  this.setState({q18: false}, function () {});
  this.setState({b18: true}, function () {});
  this.setState({q19: false}, function () {});
  this.setState({b19: true}, function () {});
  this.setState({q20: false}, function () {});
  this.setState({b20: true}, function () {});
  this.setState({q21: false}, function () {});
  this.setState({b21: true}, function () {});
  this.setState({q22: false}, function () {});
  this.setState({b22: true}, function () {});
  this.setState({q23: false}, function () {});
  this.setState({b23: true}, function () {});
  this.setState({q24: false}, function () {});
  this.setState({b24: true}, function () {});
  this.setState({q25: false}, function () {});
  this.setState({b25: true}, function () {});
  this.setState({q26: false}, function () {});
  this.setState({b26: true}, function () {});
  this.setState({q27: false}, function () {});
  this.setState({b27: true}, function () {});
  this.setState({q28: false}, function () {});
  this.setState({b28: true}, function () {});
}

toggle6() {
  this.setState(state => ({ q6: !state.q6 }));
  this.setState(state => ({ b6: !state.b6 }));

  this.setState({q1: false}, function () {});
  this.setState({b1: true}, function () {});
  this.setState({q2: false}, function () {});
  this.setState({b2: true}, function () {});
  this.setState({q3: false}, function () {});
  this.setState({b3: true}, function () {});
  this.setState({q4: false}, function () {});
  this.setState({b4: true}, function () {});
  this.setState({q5: false}, function () {});
  this.setState({b5: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q8: false}, function () {});
  this.setState({b8: true}, function () {});
  this.setState({q9: false}, function () {});
  this.setState({b9: true}, function () {});
  this.setState({q10: false}, function () {});
  this.setState({b10: true}, function () {});
  this.setState({q11: false}, function () {});
  this.setState({b11: true}, function () {});
  this.setState({q12: false}, function () {});
  this.setState({b12: true}, function () {});
  this.setState({q13: false}, function () {});
  this.setState({b13: true}, function () {});
  this.setState({q14: false}, function () {});
  this.setState({b14: true}, function () {});
  this.setState({q15: false}, function () {});
  this.setState({b15: true}, function () {});
  this.setState({q16: false}, function () {});
  this.setState({b16: true}, function () {});
  this.setState({q17: false}, function () {});
  this.setState({b17: true}, function () {});
  this.setState({q18: false}, function () {});
  this.setState({b18: true}, function () {});
  this.setState({q19: false}, function () {});
  this.setState({b19: true}, function () {});
  this.setState({q20: false}, function () {});
  this.setState({b20: true}, function () {});
  this.setState({q21: false}, function () {});
  this.setState({b21: true}, function () {});
  this.setState({q22: false}, function () {});
  this.setState({b22: true}, function () {});
  this.setState({q23: false}, function () {});
  this.setState({b23: true}, function () {});
  this.setState({q24: false}, function () {});
  this.setState({b24: true}, function () {});
  this.setState({q25: false}, function () {});
  this.setState({b25: true}, function () {});
  this.setState({q26: false}, function () {});
  this.setState({b26: true}, function () {});
  this.setState({q27: false}, function () {});
  this.setState({b27: true}, function () {});
  this.setState({q28: false}, function () {});
  this.setState({b28: true}, function () {});
}

toggle7() {
  this.setState(state => ({ q7: !state.q7 }));
  this.setState(state => ({ b7: !state.b7 }));

  this.setState({q1: false}, function () {});
  this.setState({b1: true}, function () {});
  this.setState({q2: false}, function () {});
  this.setState({b2: true}, function () {});
  this.setState({q3: false}, function () {});
  this.setState({b3: true}, function () {});
  this.setState({q4: false}, function () {});
  this.setState({b4: true}, function () {});
  this.setState({q5: false}, function () {});
  this.setState({b5: true}, function () {});
  this.setState({q6: false}, function () {});
  this.setState({b6: true}, function () {});
 
  this.setState({q8: false}, function () {});
  this.setState({b8: true}, function () {});
  this.setState({q9: false}, function () {});
  this.setState({b9: true}, function () {});
  this.setState({q10: false}, function () {});
  this.setState({b10: true}, function () {});
  this.setState({q11: false}, function () {});
  this.setState({b11: true}, function () {});
  this.setState({q12: false}, function () {});
  this.setState({b12: true}, function () {});
  this.setState({q13: false}, function () {});
  this.setState({b13: true}, function () {});
  this.setState({q14: false}, function () {});
  this.setState({b14: true}, function () {});
  this.setState({q15: false}, function () {});
  this.setState({b15: true}, function () {});
  this.setState({q16: false}, function () {});
  this.setState({b16: true}, function () {});
  this.setState({q17: false}, function () {});
  this.setState({b17: true}, function () {});
  this.setState({q18: false}, function () {});
  this.setState({b18: true}, function () {});
  this.setState({q19: false}, function () {});
  this.setState({b19: true}, function () {});
  this.setState({q20: false}, function () {});
  this.setState({b20: true}, function () {});
  this.setState({q21: false}, function () {});
  this.setState({b21: true}, function () {});
  this.setState({q22: false}, function () {});
  this.setState({b22: true}, function () {});
  this.setState({q23: false}, function () {});
  this.setState({b23: true}, function () {});
  this.setState({q24: false}, function () {});
  this.setState({b24: true}, function () {});
  this.setState({q25: false}, function () {});
  this.setState({b25: true}, function () {});
  this.setState({q26: false}, function () {});
  this.setState({b26: true}, function () {});
  this.setState({q27: false}, function () {});
  this.setState({b27: true}, function () {});
  this.setState({q28: false}, function () {});
  this.setState({b28: true}, function () {});
}

toggle8() {
  this.setState(state => ({ q8: !state.q8 }));
  this.setState(state => ({ b8: !state.b8 }));

  this.setState({q1: false}, function () {});
  this.setState({b1: true}, function () {});
  this.setState({q2: false}, function () {});
  this.setState({b2: true}, function () {});
  this.setState({q3: false}, function () {});
  this.setState({b3: true}, function () {});
  this.setState({q4: false}, function () {});
  this.setState({b4: true}, function () {});
  this.setState({q5: false}, function () {});
  this.setState({b5: true}, function () {});
  this.setState({q6: false}, function () {});
  this.setState({b6: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
 
  this.setState({q9: false}, function () {});
  this.setState({b9: true}, function () {});
  this.setState({q10: false}, function () {});
  this.setState({b10: true}, function () {});
  this.setState({q11: false}, function () {});
  this.setState({b11: true}, function () {});
  this.setState({q12: false}, function () {});
  this.setState({b12: true}, function () {});
  this.setState({q13: false}, function () {});
  this.setState({b13: true}, function () {});
  this.setState({q14: false}, function () {});
  this.setState({b14: true}, function () {});
  this.setState({q15: false}, function () {});
  this.setState({b15: true}, function () {});
  this.setState({q16: false}, function () {});
  this.setState({b16: true}, function () {});
  this.setState({q17: false}, function () {});
  this.setState({b17: true}, function () {});
  this.setState({q18: false}, function () {});
  this.setState({b18: true}, function () {});
  this.setState({q19: false}, function () {});
  this.setState({b19: true}, function () {});
  this.setState({q20: false}, function () {});
  this.setState({b20: true}, function () {});
  this.setState({q21: false}, function () {});
  this.setState({b21: true}, function () {});
  this.setState({q22: false}, function () {});
  this.setState({b22: true}, function () {});
  this.setState({q23: false}, function () {});
  this.setState({b23: true}, function () {});
  this.setState({q24: false}, function () {});
  this.setState({b24: true}, function () {});
  this.setState({q25: false}, function () {});
  this.setState({b25: true}, function () {});
  this.setState({q26: false}, function () {});
  this.setState({b26: true}, function () {});
  this.setState({q27: false}, function () {});
  this.setState({b27: true}, function () {});
  this.setState({q28: false}, function () {});
  this.setState({b28: true}, function () {});
}

toggle9() {
  this.setState(state => ({ q9: !state.q9 }));
  this.setState(state => ({ b9: !state.b9 }));

  this.setState({q1: false}, function () {});
  this.setState({b1: true}, function () {});
  this.setState({q2: false}, function () {});
  this.setState({b2: true}, function () {});
  this.setState({q3: false}, function () {});
  this.setState({b3: true}, function () {});
  this.setState({q4: false}, function () {});
  this.setState({b4: true}, function () {});
  this.setState({q5: false}, function () {});
  this.setState({b5: true}, function () {});
  this.setState({q6: false}, function () {});
  this.setState({b6: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q8: false}, function () {});
  this.setState({b8: true}, function () {});
 
  this.setState({q10: false}, function () {});
  this.setState({b10: true}, function () {});
  this.setState({q11: false}, function () {});
  this.setState({b11: true}, function () {});
  this.setState({q12: false}, function () {});
  this.setState({b12: true}, function () {});
  this.setState({q13: false}, function () {});
  this.setState({b13: true}, function () {});
  this.setState({q14: false}, function () {});
  this.setState({b14: true}, function () {});
  this.setState({q15: false}, function () {});
  this.setState({b15: true}, function () {});
  this.setState({q16: false}, function () {});
  this.setState({b16: true}, function () {});
  this.setState({q17: false}, function () {});
  this.setState({b17: true}, function () {});
  this.setState({q18: false}, function () {});
  this.setState({b18: true}, function () {});
  this.setState({q19: false}, function () {});
  this.setState({b19: true}, function () {});
  this.setState({q20: false}, function () {});
  this.setState({b20: true}, function () {});
  this.setState({q21: false}, function () {});
  this.setState({b21: true}, function () {});
  this.setState({q22: false}, function () {});
  this.setState({b22: true}, function () {});
  this.setState({q23: false}, function () {});
  this.setState({b23: true}, function () {});
  this.setState({q24: false}, function () {});
  this.setState({b24: true}, function () {});
  this.setState({q25: false}, function () {});
  this.setState({b25: true}, function () {});
  this.setState({q26: false}, function () {});
  this.setState({b26: true}, function () {});
  this.setState({q27: false}, function () {});
  this.setState({b27: true}, function () {});
  this.setState({q28: false}, function () {});
  this.setState({b28: true}, function () {});
}

toggle10() {
  this.setState(state => ({ q10: !state.q10 }));
  this.setState(state => ({ b10: !state.b10 }));

  this.setState({q1: false}, function () {});
  this.setState({b1: true}, function () {});
  this.setState({q2: false}, function () {});
  this.setState({b2: true}, function () {});
  this.setState({q3: false}, function () {});
  this.setState({b3: true}, function () {});
  this.setState({q4: false}, function () {});
  this.setState({b4: true}, function () {});
  this.setState({q5: false}, function () {});
  this.setState({b5: true}, function () {});
  this.setState({q6: false}, function () {});
  this.setState({b6: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q8: false}, function () {});
  this.setState({b8: true}, function () {});
  this.setState({q9: false}, function () {});
  this.setState({b9: true}, function () {});
  this.setState({q11: false}, function () {});
  this.setState({b11: true}, function () {});
  this.setState({q12: false}, function () {});
  this.setState({b12: true}, function () {});
  this.setState({q13: false}, function () {});
  this.setState({b13: true}, function () {});
  this.setState({q14: false}, function () {});
  this.setState({b14: true}, function () {});
  this.setState({q15: false}, function () {});
  this.setState({b15: true}, function () {});
  this.setState({q16: false}, function () {});
  this.setState({b16: true}, function () {});
  this.setState({q17: false}, function () {});
  this.setState({b17: true}, function () {});
  this.setState({q18: false}, function () {});
  this.setState({b18: true}, function () {});
  this.setState({q19: false}, function () {});
  this.setState({b19: true}, function () {});
  this.setState({q20: false}, function () {});
  this.setState({b20: true}, function () {});
  this.setState({q21: false}, function () {});
  this.setState({b21: true}, function () {});
  this.setState({q22: false}, function () {});
  this.setState({b22: true}, function () {});
  this.setState({q23: false}, function () {});
  this.setState({b23: true}, function () {});
  this.setState({q24: false}, function () {});
  this.setState({b24: true}, function () {});
  this.setState({q25: false}, function () {});
  this.setState({b25: true}, function () {});
  this.setState({q26: false}, function () {});
  this.setState({b26: true}, function () {});
  this.setState({q27: false}, function () {});
  this.setState({b27: true}, function () {});
  this.setState({q28: false}, function () {});
  this.setState({b28: true}, function () {});
}
toggle11() {
  this.setState(state => ({ q11: !state.q11 }));
  this.setState(state => ({ b11: !state.b11 }));

  this.setState({q1: false}, function () {});
  this.setState({b1: true}, function () {});
  this.setState({q2: false}, function () {});
  this.setState({b2: true}, function () {});
  this.setState({q3: false}, function () {});
  this.setState({b3: true}, function () {});
  this.setState({q4: false}, function () {});
  this.setState({b4: true}, function () {});
  this.setState({q5: false}, function () {});
  this.setState({b5: true}, function () {});
  this.setState({q6: false}, function () {});
  this.setState({b6: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q8: false}, function () {});
  this.setState({b8: true}, function () {});
  this.setState({q9: false}, function () {});
  this.setState({b9: true}, function () {});
  this.setState({q10: false}, function () {});
  this.setState({b10: true}, function () {});

  this.setState({q12: false}, function () {});
  this.setState({b12: true}, function () {});
  this.setState({q13: false}, function () {});
  this.setState({b13: true}, function () {});
  this.setState({q14: false}, function () {});
  this.setState({b14: true}, function () {});
  this.setState({q15: false}, function () {});
  this.setState({b15: true}, function () {});
  this.setState({q16: false}, function () {});
  this.setState({b16: true}, function () {});
  this.setState({q17: false}, function () {});
  this.setState({b17: true}, function () {});
  this.setState({q18: false}, function () {});
  this.setState({b18: true}, function () {});
  this.setState({q19: false}, function () {});
  this.setState({b19: true}, function () {});
  this.setState({q20: false}, function () {});
  this.setState({b20: true}, function () {});
  this.setState({q21: false}, function () {});
  this.setState({b21: true}, function () {});
  this.setState({q22: false}, function () {});
  this.setState({b22: true}, function () {});
  this.setState({q23: false}, function () {});
  this.setState({b23: true}, function () {});
  this.setState({q24: false}, function () {});
  this.setState({b24: true}, function () {});
  this.setState({q25: false}, function () {});
  this.setState({b25: true}, function () {});
  this.setState({q26: false}, function () {});
  this.setState({b26: true}, function () {});
  this.setState({q27: false}, function () {});
  this.setState({b27: true}, function () {});
  this.setState({q28: false}, function () {});
  this.setState({b28: true}, function () {});
}

toggle12() {
  this.setState(state => ({ q12: !state.q12 }));
  this.setState(state => ({ b12: !state.b12 }));

  this.setState({q1: false}, function () {});
  this.setState({b1: true}, function () {});
  this.setState({q2: false}, function () {});
  this.setState({b2: true}, function () {});
  this.setState({q3: false}, function () {});
  this.setState({b3: true}, function () {});
  this.setState({q4: false}, function () {});
  this.setState({b4: true}, function () {});
  this.setState({q5: false}, function () {});
  this.setState({b5: true}, function () {});
  this.setState({q6: false}, function () {});
  this.setState({b6: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q8: false}, function () {});
  this.setState({b8: true}, function () {});
  this.setState({q9: false}, function () {});
  this.setState({b9: true}, function () {});
  this.setState({q10: false}, function () {});
  this.setState({b10: true}, function () {});
  this.setState({q11: false}, function () {});
  this.setState({b11: true}, function () {});

  this.setState({q13: false}, function () {});
  this.setState({b13: true}, function () {});
  this.setState({q14: false}, function () {});
  this.setState({b14: true}, function () {});
  this.setState({q15: false}, function () {});
  this.setState({b15: true}, function () {});
  this.setState({q16: false}, function () {});
  this.setState({b16: true}, function () {});
  this.setState({q17: false}, function () {});
  this.setState({b17: true}, function () {});
  this.setState({q18: false}, function () {});
  this.setState({b18: true}, function () {});
  this.setState({q19: false}, function () {});
  this.setState({b19: true}, function () {});
  this.setState({q20: false}, function () {});
  this.setState({b20: true}, function () {});
  this.setState({q21: false}, function () {});
  this.setState({b21: true}, function () {});
  this.setState({q22: false}, function () {});
  this.setState({b22: true}, function () {});
  this.setState({q23: false}, function () {});
  this.setState({b23: true}, function () {});
  this.setState({q24: false}, function () {});
  this.setState({b24: true}, function () {});
  this.setState({q25: false}, function () {});
  this.setState({b25: true}, function () {});
  this.setState({q26: false}, function () {});
  this.setState({b26: true}, function () {});
  this.setState({q27: false}, function () {});
  this.setState({b27: true}, function () {});
  this.setState({q28: false}, function () {});
  this.setState({b28: true}, function () {});
}

toggle13() {
  this.setState(state => ({ q13: !state.q13 }));
  this.setState(state => ({ b13: !state.b13 }));

  this.setState({q1: false}, function () {});
  this.setState({b1: true}, function () {});
  this.setState({q2: false}, function () {});
  this.setState({b2: true}, function () {});
  this.setState({q3: false}, function () {});
  this.setState({b3: true}, function () {});
  this.setState({q4: false}, function () {});
  this.setState({b4: true}, function () {});
  this.setState({q5: false}, function () {});
  this.setState({b5: true}, function () {});
  this.setState({q6: false}, function () {});
  this.setState({b6: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q8: false}, function () {});
  this.setState({b8: true}, function () {});
  this.setState({q9: false}, function () {});
  this.setState({b9: true}, function () {});
  this.setState({q10: false}, function () {});
  this.setState({b10: true}, function () {});
  this.setState({q11: false}, function () {});
  this.setState({b11: true}, function () {});
  this.setState({q12: false}, function () {});
  this.setState({b12: true}, function () {});
  this.setState({q14: false}, function () {});
  this.setState({b14: true}, function () {});
  this.setState({q15: false}, function () {});
  this.setState({b15: true}, function () {});
  this.setState({q16: false}, function () {});
  this.setState({b16: true}, function () {});
  this.setState({q17: false}, function () {});
  this.setState({b17: true}, function () {});
  this.setState({q18: false}, function () {});
  this.setState({b18: true}, function () {});
  this.setState({q19: false}, function () {});
  this.setState({b19: true}, function () {});
  this.setState({q20: false}, function () {});
  this.setState({b20: true}, function () {});
  this.setState({q21: false}, function () {});
  this.setState({b21: true}, function () {});
  this.setState({q22: false}, function () {});
  this.setState({b22: true}, function () {});
  this.setState({q23: false}, function () {});
  this.setState({b23: true}, function () {});
  this.setState({q24: false}, function () {});
  this.setState({b24: true}, function () {});
  this.setState({q25: false}, function () {});
  this.setState({b25: true}, function () {});
  this.setState({q26: false}, function () {});
  this.setState({b26: true}, function () {});
  this.setState({q27: false}, function () {});
  this.setState({b27: true}, function () {});
  this.setState({q28: false}, function () {});
  this.setState({b28: true}, function () {});
}


toggle14() {
  this.setState(state => ({ q14: !state.q14 }));
  this.setState(state => ({ b14: !state.b14 }));

  this.setState({q1: false}, function () {});
  this.setState({b1: true}, function () {});
  this.setState({q2: false}, function () {});
  this.setState({b2: true}, function () {});
  this.setState({q3: false}, function () {});
  this.setState({b3: true}, function () {});
  this.setState({q4: false}, function () {});
  this.setState({b4: true}, function () {});
  this.setState({q5: false}, function () {});
  this.setState({b5: true}, function () {});
  this.setState({q6: false}, function () {});
  this.setState({b6: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q8: false}, function () {});
  this.setState({b8: true}, function () {});
  this.setState({q9: false}, function () {});
  this.setState({b9: true}, function () {});
  this.setState({q10: false}, function () {});
  this.setState({b10: true}, function () {});
  this.setState({q11: false}, function () {});
  this.setState({b11: true}, function () {});
  this.setState({q12: false}, function () {});
  this.setState({b12: true}, function () {});
  this.setState({q13: false}, function () {});
  this.setState({b13: true}, function () {});
  this.setState({q15: false}, function () {});
  this.setState({b15: true}, function () {});
  this.setState({q16: false}, function () {});
  this.setState({b16: true}, function () {});
  this.setState({q17: false}, function () {});
  this.setState({b17: true}, function () {});
  this.setState({q18: false}, function () {});
  this.setState({b18: true}, function () {});
  this.setState({q19: false}, function () {});
  this.setState({b19: true}, function () {});
  this.setState({q20: false}, function () {});
  this.setState({b20: true}, function () {});
  this.setState({q21: false}, function () {});
  this.setState({b21: true}, function () {});
  this.setState({q22: false}, function () {});
  this.setState({b22: true}, function () {});
  this.setState({q23: false}, function () {});
  this.setState({b23: true}, function () {});
  this.setState({q24: false}, function () {});
  this.setState({b24: true}, function () {});
  this.setState({q25: false}, function () {});
  this.setState({b25: true}, function () {});
  this.setState({q26: false}, function () {});
  this.setState({b26: true}, function () {});
  this.setState({q27: false}, function () {});
  this.setState({b27: true}, function () {});
  this.setState({q28: false}, function () {});
  this.setState({b28: true}, function () {});
}

toggle15() {
  this.setState(state => ({ q15: !state.q15 }));
  this.setState(state => ({ b15: !state.b15 }));

  this.setState({q1: false}, function () {});
  this.setState({b1: true}, function () {});
  this.setState({q2: false}, function () {});
  this.setState({b2: true}, function () {});
  this.setState({q3: false}, function () {});
  this.setState({b3: true}, function () {});
  this.setState({q4: false}, function () {});
  this.setState({b4: true}, function () {});
  this.setState({q5: false}, function () {});
  this.setState({b5: true}, function () {});
  this.setState({q6: false}, function () {});
  this.setState({b6: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q8: false}, function () {});
  this.setState({b8: true}, function () {});
  this.setState({q9: false}, function () {});
  this.setState({b9: true}, function () {});
  this.setState({q10: false}, function () {});
  this.setState({b10: true}, function () {});
  this.setState({q11: false}, function () {});
  this.setState({b11: true}, function () {});
  this.setState({q12: false}, function () {});
  this.setState({b12: true}, function () {});
  this.setState({q14: false}, function () {});
  this.setState({b14: true}, function () {});
  this.setState({q13: false}, function () {});
  this.setState({b13: true}, function () {});
  this.setState({q16: false}, function () {});
  this.setState({b16: true}, function () {});
  this.setState({q17: false}, function () {});
  this.setState({b17: true}, function () {});
  this.setState({q18: false}, function () {});
  this.setState({b18: true}, function () {});
  this.setState({q19: false}, function () {});
  this.setState({b19: true}, function () {});
  this.setState({q20: false}, function () {});
  this.setState({b20: true}, function () {});
  this.setState({q21: false}, function () {});
  this.setState({b21: true}, function () {});
  this.setState({q22: false}, function () {});
  this.setState({b22: true}, function () {});
  this.setState({q23: false}, function () {});
  this.setState({b23: true}, function () {});
  this.setState({q24: false}, function () {});
  this.setState({b24: true}, function () {});
  this.setState({q25: false}, function () {});
  this.setState({b25: true}, function () {});
  this.setState({q26: false}, function () {});
  this.setState({b26: true}, function () {});
  this.setState({q27: false}, function () {});
  this.setState({b27: true}, function () {});
  this.setState({q28: false}, function () {});
  this.setState({b28: true}, function () {});
}

toggle16() {
  this.setState(state => ({ q16: !state.q16 }));
  this.setState(state => ({ b16: !state.b16 }));

  this.setState({q1: false}, function () {});
  this.setState({b1: true}, function () {});
  this.setState({q2: false}, function () {});
  this.setState({b2: true}, function () {});
  this.setState({q3: false}, function () {});
  this.setState({b3: true}, function () {});
  this.setState({q4: false}, function () {});
  this.setState({b4: true}, function () {});
  this.setState({q5: false}, function () {});
  this.setState({b5: true}, function () {});
  this.setState({q6: false}, function () {});
  this.setState({b6: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q8: false}, function () {});
  this.setState({b8: true}, function () {});
  this.setState({q9: false}, function () {});
  this.setState({b9: true}, function () {});
  this.setState({q10: false}, function () {});
  this.setState({b10: true}, function () {});
  this.setState({q11: false}, function () {});
  this.setState({b11: true}, function () {});
  this.setState({q12: false}, function () {});
  this.setState({b12: true}, function () {});
  this.setState({q14: false}, function () {});
  this.setState({b14: true}, function () {});
  this.setState({q15: false}, function () {});
  this.setState({b15: true}, function () {});
  this.setState({q13: false}, function () {});
  this.setState({b13: true}, function () {});
  this.setState({q17: false}, function () {});
  this.setState({b17: true}, function () {});
  this.setState({q18: false}, function () {});
  this.setState({b18: true}, function () {});
  this.setState({q19: false}, function () {});
  this.setState({b19: true}, function () {});
  this.setState({q20: false}, function () {});
  this.setState({b20: true}, function () {});
  this.setState({q21: false}, function () {});
  this.setState({b21: true}, function () {});
  this.setState({q22: false}, function () {});
  this.setState({b22: true}, function () {});
  this.setState({q23: false}, function () {});
  this.setState({b23: true}, function () {});
  this.setState({q24: false}, function () {});
  this.setState({b24: true}, function () {});
  this.setState({q25: false}, function () {});
  this.setState({b25: true}, function () {});
  this.setState({q26: false}, function () {});
  this.setState({b26: true}, function () {});
  this.setState({q27: false}, function () {});
  this.setState({b27: true}, function () {});
  this.setState({q28: false}, function () {});
  this.setState({b28: true}, function () {});
}

toggle17() {
  this.setState(state => ({ q17: !state.q17 }));
  this.setState(state => ({ b17: !state.b17 }));

  this.setState({q1: false}, function () {});
  this.setState({b1: true}, function () {});
  this.setState({q2: false}, function () {});
  this.setState({b2: true}, function () {});
  this.setState({q3: false}, function () {});
  this.setState({b3: true}, function () {});
  this.setState({q4: false}, function () {});
  this.setState({b4: true}, function () {});
  this.setState({q5: false}, function () {});
  this.setState({b5: true}, function () {});
  this.setState({q6: false}, function () {});
  this.setState({b6: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q8: false}, function () {});
  this.setState({b8: true}, function () {});
  this.setState({q9: false}, function () {});
  this.setState({b9: true}, function () {});
  this.setState({q10: false}, function () {});
  this.setState({b10: true}, function () {});
  this.setState({q11: false}, function () {});
  this.setState({b11: true}, function () {});
  this.setState({q12: false}, function () {});
  this.setState({b12: true}, function () {});
  this.setState({q14: false}, function () {});
  this.setState({b14: true}, function () {});
  this.setState({q15: false}, function () {});
  this.setState({b15: true}, function () {});
  this.setState({q16: false}, function () {});
  this.setState({b16: true}, function () {});
  this.setState({q13: false}, function () {});
  this.setState({b13: true}, function () {});
  this.setState({q18: false}, function () {});
  this.setState({b18: true}, function () {});
  this.setState({q19: false}, function () {});
  this.setState({b19: true}, function () {});
  this.setState({q20: false}, function () {});
  this.setState({b20: true}, function () {});
  this.setState({q21: false}, function () {});
  this.setState({b21: true}, function () {});
  this.setState({q22: false}, function () {});
  this.setState({b22: true}, function () {});
  this.setState({q23: false}, function () {});
  this.setState({b23: true}, function () {});
  this.setState({q24: false}, function () {});
  this.setState({b24: true}, function () {});
  this.setState({q25: false}, function () {});
  this.setState({b25: true}, function () {});
  this.setState({q26: false}, function () {});
  this.setState({b26: true}, function () {});
  this.setState({q27: false}, function () {});
  this.setState({b27: true}, function () {});
  this.setState({q28: false}, function () {});
  this.setState({b28: true}, function () {});
}

toggle18() {
  this.setState(state => ({ q18: !state.q18 }));
  this.setState(state => ({ b18: !state.b18 }));

  this.setState({q1: false}, function () {});
  this.setState({b1: true}, function () {});
  this.setState({q2: false}, function () {});
  this.setState({b2: true}, function () {});
  this.setState({q3: false}, function () {});
  this.setState({b3: true}, function () {});
  this.setState({q4: false}, function () {});
  this.setState({b4: true}, function () {});
  this.setState({q5: false}, function () {});
  this.setState({b5: true}, function () {});
  this.setState({q6: false}, function () {});
  this.setState({b6: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q8: false}, function () {});
  this.setState({b8: true}, function () {});
  this.setState({q9: false}, function () {});
  this.setState({b9: true}, function () {});
  this.setState({q10: false}, function () {});
  this.setState({b10: true}, function () {});
  this.setState({q11: false}, function () {});
  this.setState({b11: true}, function () {});
  this.setState({q12: false}, function () {});
  this.setState({b12: true}, function () {});
  this.setState({q14: false}, function () {});
  this.setState({b14: true}, function () {});
  this.setState({q15: false}, function () {});
  this.setState({b15: true}, function () {});
  this.setState({q16: false}, function () {});
  this.setState({b16: true}, function () {});
  this.setState({q17: false}, function () {});
  this.setState({b17: true}, function () {});
  this.setState({q13: false}, function () {});
  this.setState({b13: true}, function () {});
  this.setState({q19: false}, function () {});
  this.setState({b19: true}, function () {});
  this.setState({q20: false}, function () {});
  this.setState({b20: true}, function () {});
  this.setState({q21: false}, function () {});
  this.setState({b21: true}, function () {});
  this.setState({q22: false}, function () {});
  this.setState({b22: true}, function () {});
  this.setState({q23: false}, function () {});
  this.setState({b23: true}, function () {});
  this.setState({q24: false}, function () {});
  this.setState({b24: true}, function () {});
  this.setState({q25: false}, function () {});
  this.setState({b25: true}, function () {});
  this.setState({q26: false}, function () {});
  this.setState({b26: true}, function () {});
  this.setState({q27: false}, function () {});
  this.setState({b27: true}, function () {});
  this.setState({q28: false}, function () {});
  this.setState({b28: true}, function () {});
}

toggle19() {
  this.setState(state => ({ q19: !state.q19 }));
  this.setState(state => ({ b19: !state.b19 }));

  this.setState({q1: false}, function () {});
  this.setState({b1: true}, function () {});
  this.setState({q2: false}, function () {});
  this.setState({b2: true}, function () {});
  this.setState({q3: false}, function () {});
  this.setState({b3: true}, function () {});
  this.setState({q4: false}, function () {});
  this.setState({b4: true}, function () {});
  this.setState({q5: false}, function () {});
  this.setState({b5: true}, function () {});
  this.setState({q6: false}, function () {});
  this.setState({b6: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q8: false}, function () {});
  this.setState({b8: true}, function () {});
  this.setState({q9: false}, function () {});
  this.setState({b9: true}, function () {});
  this.setState({q10: false}, function () {});
  this.setState({b10: true}, function () {});
  this.setState({q11: false}, function () {});
  this.setState({b11: true}, function () {});
  this.setState({q12: false}, function () {});
  this.setState({b12: true}, function () {});
  this.setState({q14: false}, function () {});
  this.setState({b14: true}, function () {});
  this.setState({q15: false}, function () {});
  this.setState({b15: true}, function () {});
  this.setState({q16: false}, function () {});
  this.setState({b16: true}, function () {});
  this.setState({q17: false}, function () {});
  this.setState({b17: true}, function () {});
  this.setState({q18: false}, function () {});
  this.setState({b18: true}, function () {});
  this.setState({q13: false}, function () {});
  this.setState({b13: true}, function () {});
  this.setState({q20: false}, function () {});
  this.setState({b20: true}, function () {});
  this.setState({q21: false}, function () {});
  this.setState({b21: true}, function () {});
  this.setState({q22: false}, function () {});
  this.setState({b22: true}, function () {});
  this.setState({q23: false}, function () {});
  this.setState({b23: true}, function () {});
  this.setState({q24: false}, function () {});
  this.setState({b24: true}, function () {});
  this.setState({q25: false}, function () {});
  this.setState({b25: true}, function () {});
  this.setState({q26: false}, function () {});
  this.setState({b26: true}, function () {});
  this.setState({q27: false}, function () {});
  this.setState({b27: true}, function () {});
  this.setState({q28: false}, function () {});
  this.setState({b28: true}, function () {});
}

toggle20() {
  this.setState(state => ({ q20: !state.q20 }));
  this.setState(state => ({ b20: !state.b20 }));

  this.setState({q1: false}, function () {});
  this.setState({b1: true}, function () {});
  this.setState({q2: false}, function () {});
  this.setState({b2: true}, function () {});
  this.setState({q3: false}, function () {});
  this.setState({b3: true}, function () {});
  this.setState({q4: false}, function () {});
  this.setState({b4: true}, function () {});
  this.setState({q5: false}, function () {});
  this.setState({b5: true}, function () {});
  this.setState({q6: false}, function () {});
  this.setState({b6: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q8: false}, function () {});
  this.setState({b8: true}, function () {});
  this.setState({q9: false}, function () {});
  this.setState({b9: true}, function () {});
  this.setState({q10: false}, function () {});
  this.setState({b10: true}, function () {});
  this.setState({q11: false}, function () {});
  this.setState({b11: true}, function () {});
  this.setState({q12: false}, function () {});
  this.setState({b12: true}, function () {});
  this.setState({q14: false}, function () {});
  this.setState({b14: true}, function () {});
  this.setState({q15: false}, function () {});
  this.setState({b15: true}, function () {});
  this.setState({q16: false}, function () {});
  this.setState({b16: true}, function () {});
  this.setState({q17: false}, function () {});
  this.setState({b17: true}, function () {});
  this.setState({q18: false}, function () {});
  this.setState({b18: true}, function () {});
  this.setState({q19: false}, function () {});
  this.setState({b19: true}, function () {});
  this.setState({q13: false}, function () {});
  this.setState({b13: true}, function () {});
  this.setState({q21: false}, function () {});
  this.setState({b21: true}, function () {});
  this.setState({q22: false}, function () {});
  this.setState({b22: true}, function () {});
  this.setState({q23: false}, function () {});
  this.setState({b23: true}, function () {});
  this.setState({q24: false}, function () {});
  this.setState({b24: true}, function () {});
  this.setState({q25: false}, function () {});
  this.setState({b25: true}, function () {});
  this.setState({q26: false}, function () {});
  this.setState({b26: true}, function () {});
  this.setState({q27: false}, function () {});
  this.setState({b27: true}, function () {});
  this.setState({q28: false}, function () {});
  this.setState({b28: true}, function () {});
}

toggle21() {
  this.setState(state => ({ q21: !state.q21 }));
  this.setState(state => ({ b21: !state.b21 }));

  this.setState({q1: false}, function () {});
  this.setState({b1: true}, function () {});
  this.setState({q2: false}, function () {});
  this.setState({b2: true}, function () {});
  this.setState({q3: false}, function () {});
  this.setState({b3: true}, function () {});
  this.setState({q4: false}, function () {});
  this.setState({b4: true}, function () {});
  this.setState({q5: false}, function () {});
  this.setState({b5: true}, function () {});
  this.setState({q6: false}, function () {});
  this.setState({b6: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q8: false}, function () {});
  this.setState({b8: true}, function () {});
  this.setState({q9: false}, function () {});
  this.setState({b9: true}, function () {});
  this.setState({q10: false}, function () {});
  this.setState({b10: true}, function () {});
  this.setState({q11: false}, function () {});
  this.setState({b11: true}, function () {});
  this.setState({q12: false}, function () {});
  this.setState({b12: true}, function () {});
  this.setState({q14: false}, function () {});
  this.setState({b14: true}, function () {});
  this.setState({q15: false}, function () {});
  this.setState({b15: true}, function () {});
  this.setState({q16: false}, function () {});
  this.setState({b16: true}, function () {});
  this.setState({q17: false}, function () {});
  this.setState({b17: true}, function () {});
  this.setState({q18: false}, function () {});
  this.setState({b18: true}, function () {});
  this.setState({q19: false}, function () {});
  this.setState({b19: true}, function () {});
  this.setState({q13: false}, function () {});
  this.setState({b13: true}, function () {});
  this.setState({q20: false}, function () {});
  this.setState({b20: true}, function () {});
  this.setState({q22: false}, function () {});
  this.setState({b22: true}, function () {});
  this.setState({q23: false}, function () {});
  this.setState({b23: true}, function () {});
  this.setState({q24: false}, function () {});
  this.setState({b24: true}, function () {});
  this.setState({q25: false}, function () {});
  this.setState({b25: true}, function () {});
  this.setState({q26: false}, function () {});
  this.setState({b26: true}, function () {});
  this.setState({q27: false}, function () {});
  this.setState({b27: true}, function () {});
  this.setState({q28: false}, function () {});
  this.setState({b28: true}, function () {});
}

toggle22() {
  this.setState(state => ({ q22: !state.q22 }));
  this.setState(state => ({ b22: !state.b22 }));

  this.setState({q1: false}, function () {});
  this.setState({b1: true}, function () {});
  this.setState({q2: false}, function () {});
  this.setState({b2: true}, function () {});
  this.setState({q3: false}, function () {});
  this.setState({b3: true}, function () {});
  this.setState({q4: false}, function () {});
  this.setState({b4: true}, function () {});
  this.setState({q5: false}, function () {});
  this.setState({b5: true}, function () {});
  this.setState({q6: false}, function () {});
  this.setState({b6: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q8: false}, function () {});
  this.setState({b8: true}, function () {});
  this.setState({q9: false}, function () {});
  this.setState({b9: true}, function () {});
  this.setState({q10: false}, function () {});
  this.setState({b10: true}, function () {});
  this.setState({q11: false}, function () {});
  this.setState({b11: true}, function () {});
  this.setState({q12: false}, function () {});
  this.setState({b12: true}, function () {});
  this.setState({q14: false}, function () {});
  this.setState({b14: true}, function () {});
  this.setState({q15: false}, function () {});
  this.setState({b15: true}, function () {});
  this.setState({q16: false}, function () {});
  this.setState({b16: true}, function () {});
  this.setState({q17: false}, function () {});
  this.setState({b17: true}, function () {});
  this.setState({q18: false}, function () {});
  this.setState({b18: true}, function () {});
  this.setState({q19: false}, function () {});
  this.setState({b19: true}, function () {});
  this.setState({q13: false}, function () {});
  this.setState({b13: true}, function () {});
  this.setState({q21: false}, function () {});
  this.setState({b21: true}, function () {});
  this.setState({q20: false}, function () {});
  this.setState({b20: true}, function () {});
  this.setState({q23: false}, function () {});
  this.setState({b23: true}, function () {});
  this.setState({q24: false}, function () {});
  this.setState({b24: true}, function () {});
  this.setState({q25: false}, function () {});
  this.setState({b25: true}, function () {});
  this.setState({q26: false}, function () {});
  this.setState({b26: true}, function () {});
  this.setState({q27: false}, function () {});
  this.setState({b27: true}, function () {});
  this.setState({q28: false}, function () {});
  this.setState({b28: true}, function () {});
}

toggle23() {
  this.setState(state => ({ q23: !state.q23 }));
  this.setState(state => ({ b23: !state.b23 }));

  this.setState({q1: false}, function () {});
  this.setState({b1: true}, function () {});
  this.setState({q2: false}, function () {});
  this.setState({b2: true}, function () {});
  this.setState({q3: false}, function () {});
  this.setState({b3: true}, function () {});
  this.setState({q4: false}, function () {});
  this.setState({b4: true}, function () {});
  this.setState({q5: false}, function () {});
  this.setState({b5: true}, function () {});
  this.setState({q6: false}, function () {});
  this.setState({b6: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q8: false}, function () {});
  this.setState({b8: true}, function () {});
  this.setState({q9: false}, function () {});
  this.setState({b9: true}, function () {});
  this.setState({q10: false}, function () {});
  this.setState({b10: true}, function () {});
  this.setState({q11: false}, function () {});
  this.setState({b11: true}, function () {});
  this.setState({q12: false}, function () {});
  this.setState({b12: true}, function () {});
  this.setState({q14: false}, function () {});
  this.setState({b14: true}, function () {});
  this.setState({q15: false}, function () {});
  this.setState({b15: true}, function () {});
  this.setState({q16: false}, function () {});
  this.setState({b16: true}, function () {});
  this.setState({q17: false}, function () {});
  this.setState({b17: true}, function () {});
  this.setState({q18: false}, function () {});
  this.setState({b18: true}, function () {});
  this.setState({q19: false}, function () {});
  this.setState({b19: true}, function () {});
  this.setState({q13: false}, function () {});
  this.setState({b13: true}, function () {});
  this.setState({q21: false}, function () {});
  this.setState({b21: true}, function () {});
  this.setState({q22: false}, function () {});
  this.setState({b22: true}, function () {});
  this.setState({q20: false}, function () {});
  this.setState({b20: true}, function () {});
  this.setState({q24: false}, function () {});
  this.setState({b24: true}, function () {});
  this.setState({q25: false}, function () {});
  this.setState({b25: true}, function () {});
  this.setState({q26: false}, function () {});
  this.setState({b26: true}, function () {});
  this.setState({q27: false}, function () {});
  this.setState({b27: true}, function () {});
  this.setState({q28: false}, function () {});
  this.setState({b28: true}, function () {});
}

toggle24() {
  this.setState(state => ({ q24: !state.q24 }));
  this.setState(state => ({ b24: !state.b24 }));

  this.setState({q1: false}, function () {});
  this.setState({b1: true}, function () {});
  this.setState({q2: false}, function () {});
  this.setState({b2: true}, function () {});
  this.setState({q3: false}, function () {});
  this.setState({b3: true}, function () {});
  this.setState({q4: false}, function () {});
  this.setState({b4: true}, function () {});
  this.setState({q5: false}, function () {});
  this.setState({b5: true}, function () {});
  this.setState({q6: false}, function () {});
  this.setState({b6: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q8: false}, function () {});
  this.setState({b8: true}, function () {});
  this.setState({q9: false}, function () {});
  this.setState({b9: true}, function () {});
  this.setState({q10: false}, function () {});
  this.setState({b10: true}, function () {});
  this.setState({q11: false}, function () {});
  this.setState({b11: true}, function () {});
  this.setState({q12: false}, function () {});
  this.setState({b12: true}, function () {});
  this.setState({q14: false}, function () {});
  this.setState({b14: true}, function () {});
  this.setState({q15: false}, function () {});
  this.setState({b15: true}, function () {});
  this.setState({q16: false}, function () {});
  this.setState({b16: true}, function () {});
  this.setState({q17: false}, function () {});
  this.setState({b17: true}, function () {});
  this.setState({q18: false}, function () {});
  this.setState({b18: true}, function () {});
  this.setState({q19: false}, function () {});
  this.setState({b19: true}, function () {});
  this.setState({q13: false}, function () {});
  this.setState({b13: true}, function () {});
  this.setState({q21: false}, function () {});
  this.setState({b21: true}, function () {});
  this.setState({q22: false}, function () {});
  this.setState({b22: true}, function () {});
  this.setState({q23: false}, function () {});
  this.setState({b23: true}, function () {});
  this.setState({q20: false}, function () {});
  this.setState({b20: true}, function () {});
  this.setState({q25: false}, function () {});
  this.setState({b25: true}, function () {});
  this.setState({q26: false}, function () {});
  this.setState({b26: true}, function () {});
  this.setState({q27: false}, function () {});
  this.setState({b27: true}, function () {});
  this.setState({q28: false}, function () {});
  this.setState({b28: true}, function () {});
}

toggle25() {
  this.setState(state => ({ q25: !state.q25 }));
  this.setState(state => ({ b25: !state.b25 }));

  this.setState({q1: false}, function () {});
  this.setState({b1: true}, function () {});
  this.setState({q2: false}, function () {});
  this.setState({b2: true}, function () {});
  this.setState({q3: false}, function () {});
  this.setState({b3: true}, function () {});
  this.setState({q4: false}, function () {});
  this.setState({b4: true}, function () {});
  this.setState({q5: false}, function () {});
  this.setState({b5: true}, function () {});
  this.setState({q6: false}, function () {});
  this.setState({b6: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q8: false}, function () {});
  this.setState({b8: true}, function () {});
  this.setState({q9: false}, function () {});
  this.setState({b9: true}, function () {});
  this.setState({q10: false}, function () {});
  this.setState({b10: true}, function () {});
  this.setState({q11: false}, function () {});
  this.setState({b11: true}, function () {});
  this.setState({q12: false}, function () {});
  this.setState({b12: true}, function () {});
  this.setState({q14: false}, function () {});
  this.setState({b14: true}, function () {});
  this.setState({q15: false}, function () {});
  this.setState({b15: true}, function () {});
  this.setState({q16: false}, function () {});
  this.setState({b16: true}, function () {});
  this.setState({q17: false}, function () {});
  this.setState({b17: true}, function () {});
  this.setState({q18: false}, function () {});
  this.setState({b18: true}, function () {});
  this.setState({q19: false}, function () {});
  this.setState({b19: true}, function () {});
  this.setState({q13: false}, function () {});
  this.setState({b13: true}, function () {});
  this.setState({q21: false}, function () {});
  this.setState({b21: true}, function () {});
  this.setState({q22: false}, function () {});
  this.setState({b22: true}, function () {});
  this.setState({q23: false}, function () {});
  this.setState({b23: true}, function () {});
  this.setState({q24: false}, function () {});
  this.setState({b24: true}, function () {});
  this.setState({q20: false}, function () {});
  this.setState({b20: true}, function () {});
  this.setState({q26: false}, function () {});
  this.setState({b26: true}, function () {});
  this.setState({q27: false}, function () {});
  this.setState({b27: true}, function () {});
  this.setState({q28: false}, function () {});
  this.setState({b28: true}, function () {});
}

toggle26() {
  this.setState(state => ({ q26: !state.q26 }));
  this.setState(state => ({ b26: !state.b26 }));

  this.setState({q1: false}, function () {});
  this.setState({b1: true}, function () {});
  this.setState({q2: false}, function () {});
  this.setState({b2: true}, function () {});
  this.setState({q3: false}, function () {});
  this.setState({b3: true}, function () {});
  this.setState({q4: false}, function () {});
  this.setState({b4: true}, function () {});
  this.setState({q5: false}, function () {});
  this.setState({b5: true}, function () {});
  this.setState({q6: false}, function () {});
  this.setState({b6: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q8: false}, function () {});
  this.setState({b8: true}, function () {});
  this.setState({q9: false}, function () {});
  this.setState({b9: true}, function () {});
  this.setState({q10: false}, function () {});
  this.setState({b10: true}, function () {});
  this.setState({q11: false}, function () {});
  this.setState({b11: true}, function () {});
  this.setState({q12: false}, function () {});
  this.setState({b12: true}, function () {});
  this.setState({q14: false}, function () {});
  this.setState({b14: true}, function () {});
  this.setState({q15: false}, function () {});
  this.setState({b15: true}, function () {});
  this.setState({q16: false}, function () {});
  this.setState({b16: true}, function () {});
  this.setState({q17: false}, function () {});
  this.setState({b17: true}, function () {});
  this.setState({q18: false}, function () {});
  this.setState({b18: true}, function () {});
  this.setState({q19: false}, function () {});
  this.setState({b19: true}, function () {});
  this.setState({q13: false}, function () {});
  this.setState({b13: true}, function () {});
  this.setState({q21: false}, function () {});
  this.setState({b21: true}, function () {});
  this.setState({q22: false}, function () {});
  this.setState({b22: true}, function () {});
  this.setState({q23: false}, function () {});
  this.setState({b23: true}, function () {});
  this.setState({q24: false}, function () {});
  this.setState({b24: true}, function () {});
  this.setState({q25: false}, function () {});
  this.setState({b25: true}, function () {});
  this.setState({q20: false}, function () {});
  this.setState({b20: true}, function () {});
  this.setState({q27: false}, function () {});
  this.setState({b27: true}, function () {});
  this.setState({q28: false}, function () {});
  this.setState({b28: true}, function () {});
}

toggle27() {
  this.setState(state => ({ q27: !state.q27 }));
  this.setState(state => ({ b27: !state.b27 }));

  this.setState({q1: false}, function () {});
  this.setState({b1: true}, function () {});
  this.setState({q2: false}, function () {});
  this.setState({b2: true}, function () {});
  this.setState({q3: false}, function () {});
  this.setState({b3: true}, function () {});
  this.setState({q4: false}, function () {});
  this.setState({b4: true}, function () {});
  this.setState({q5: false}, function () {});
  this.setState({b5: true}, function () {});
  this.setState({q6: false}, function () {});
  this.setState({b6: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q8: false}, function () {});
  this.setState({b8: true}, function () {});
  this.setState({q9: false}, function () {});
  this.setState({b9: true}, function () {});
  this.setState({q10: false}, function () {});
  this.setState({b10: true}, function () {});
  this.setState({q11: false}, function () {});
  this.setState({b11: true}, function () {});
  this.setState({q12: false}, function () {});
  this.setState({b12: true}, function () {});
  this.setState({q14: false}, function () {});
  this.setState({b14: true}, function () {});
  this.setState({q15: false}, function () {});
  this.setState({b15: true}, function () {});
  this.setState({q16: false}, function () {});
  this.setState({b16: true}, function () {});
  this.setState({q17: false}, function () {});
  this.setState({b17: true}, function () {});
  this.setState({q18: false}, function () {});
  this.setState({b18: true}, function () {});
  this.setState({q19: false}, function () {});
  this.setState({b19: true}, function () {});
  this.setState({q13: false}, function () {});
  this.setState({b13: true}, function () {});
  this.setState({q21: false}, function () {});
  this.setState({b21: true}, function () {});
  this.setState({q22: false}, function () {});
  this.setState({b22: true}, function () {});
  this.setState({q23: false}, function () {});
  this.setState({b23: true}, function () {});
  this.setState({q24: false}, function () {});
  this.setState({b24: true}, function () {});
  this.setState({q25: false}, function () {});
  this.setState({b25: true}, function () {});
  this.setState({q26: false}, function () {});
  this.setState({b26: true}, function () {});
  this.setState({q20: false}, function () {});
  this.setState({b20: true}, function () {});
  this.setState({q28: false}, function () {});
  this.setState({b28: true}, function () {});
}

toggle28() {
  this.setState(state => ({ q28: !state.q28 }));
  this.setState(state => ({ b28: !state.b28 }));

  this.setState({q1: false}, function () {});
  this.setState({b1: true}, function () {});
  this.setState({q2: false}, function () {});
  this.setState({b2: true}, function () {});
  this.setState({q3: false}, function () {});
  this.setState({b3: true}, function () {});
  this.setState({q4: false}, function () {});
  this.setState({b4: true}, function () {});
  this.setState({q5: false}, function () {});
  this.setState({b5: true}, function () {});
  this.setState({q6: false}, function () {});
  this.setState({b6: true}, function () {});
  this.setState({q7: false}, function () {});
  this.setState({b7: true}, function () {});
  this.setState({q8: false}, function () {});
  this.setState({b8: true}, function () {});
  this.setState({q9: false}, function () {});
  this.setState({b9: true}, function () {});
  this.setState({q10: false}, function () {});
  this.setState({b10: true}, function () {});
  this.setState({q11: false}, function () {});
  this.setState({b11: true}, function () {});
  this.setState({q12: false}, function () {});
  this.setState({b12: true}, function () {});
  this.setState({q14: false}, function () {});
  this.setState({b14: true}, function () {});
  this.setState({q15: false}, function () {});
  this.setState({b15: true}, function () {});
  this.setState({q16: false}, function () {});
  this.setState({b16: true}, function () {});
  this.setState({q17: false}, function () {});
  this.setState({b17: true}, function () {});
  this.setState({q18: false}, function () {});
  this.setState({b18: true}, function () {});
  this.setState({q19: false}, function () {});
  this.setState({b19: true}, function () {});
  this.setState({q13: false}, function () {});
  this.setState({b13: true}, function () {});
  this.setState({q21: false}, function () {});
  this.setState({b21: true}, function () {});
  this.setState({q22: false}, function () {});
  this.setState({b22: true}, function () {});
  this.setState({q23: false}, function () {});
  this.setState({b23: true}, function () {});
  this.setState({q24: false}, function () {});
  this.setState({b24: true}, function () {});
  this.setState({q25: false}, function () {});
  this.setState({b25: true}, function () {});
  this.setState({q26: false}, function () {});
  this.setState({b26: true}, function () {});
  this.setState({q27: false}, function () {});
  this.setState({b27: true}, function () {});
  this.setState({q20: false}, function () {});
  this.setState({b20: true}, function () {});
}
componentDidMount(){
      
  $(document).ready(function(){
    $("#myInput").on("keyup", function() {
      var value = $(this).val().toLowerCase();
      $("#myData h5").filter(function() {
        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
      });
  
    });
  });
}
   render(){
  

       return(
        <div>
       <HeaderLinks></HeaderLinks>
        {/* <div class=""> */}
       <CommonHeder></CommonHeder>
       <div style={{marginTop: '6rem'}} className="margin">
        </div>
        <section className="heart-banner-sec-wrap banner-position">
          <div className=" heart-banner-sec ">
            <div className="container pt-4 mt-2">
              <h1 className=""><strong>Terms of Service</strong></h1>
              {/* <h2 class="roboto-reg-24px my-4">Get the right answers to your questions</h2> */}
              <div className="input-group " style={{height: '75px', boxShadow: '0 17px 40px rgba(92, 103, 108, 0.2)', backgroundColor: '#ffffff', borderRadius: '2rem'}}>
              <input type="text" className="form-control m-0" placeholder="Search for help.." id="myInput"  style={{borderTopLeftRadius: '2rem', borderBottomLeftRadius: '2rem', height: '75px', boxShadow: '0 17px 40px rgba(92, 103, 108, 0.2)', backgroundColor: '#ffffff'}} required />
                <div className="valid-tooltip">
                  Looks good!
                </div>
                <div className="input-group-prepend border-0 d-flex justify-content-center">
                  <span className="btn btn-outline-primary input-group-text border-0 justify-content-center" style={{cursor: 'pointer', borderBottomRightRadius: '2rem', borderTopRightRadius: '2rem', backgroundColor: '#4f5be7', width: '160px', color: 'white'}} id="validationTooltip01">SEARCH</span>
                </div>
              </div>
            </div>
            {/* eo-container*/}
            <div className="d-flex justify-content-center" id="secc1">
              <a style={{scrollBehavior: '[ auto | smooth ]'}} href="#secc1"> <img className="img-fluid d-none d-md-block d-lg-block btn-hover-white1" src="./img/111.png" /></a>
            </div>
          </div>
          {/* eo-heart-banner-sec */}
        </section>
        {/* eo-heart-banner-sec-wrap */}
        {/* ------------------------------------------------------heart-banner-sec over------------------------------------------------------------------ */}
        
        {/* eo-heart-banner-sec-wrap */}
        {/* ------------------------------------------------------heart-banner-sec over------------------------------------------------------------------ */}
        <section className="container" id="myData">
          <div className=" mt-5">
            <div className="text-center">
              <div className="card-block  p-2 circle">
                <div className="pr-5 pb-5 pl-5 hc-accordian-wrap">
                  <div className="accordion" id="accordionIhc">
                    <div className="card ">
                      <div className="card-header" id="headingOne">
                        <h5 className="acc-header collapse-color mb-0" style={{color:this.state.q1?'#2C333C':'#4F5BE7'}}>
                          Definitions
                          {this.state.b1?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle1} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle1} className="fa fa-minus-circle  rounded-circle " /></button>}
                        </h5>
                      </div>
                      <Collapse isOpen={this.state.q1}>
                      <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordionIhc">
                        <div className="card-body border-0">
                          <p className=" roboto-reg-18px"></p>
                          <p><span style={{fontSize: '13pt'}}>a. “truGeny” as a brand means True Health Lab Pvt Ltd. whose principal place of business is at _______________________________.</span></p>
                          <p><span style={{fontSize: '13pt'}}>b. "truGeny Research" means all the scientific research that truGeny performs or intends to perform with an objective to publish in a peer-</span><span style={{fontSize: '13pt'}}>reviewed scientific journal. “truGeny Research uses genetic and self-reported information from the users who have provided an informed</span></p>
                          <p><span style={{fontSize: '13pt'}}>consent as per the consent document available on the application.</span><span style={{fontSize: '13pt'}}>c. "Product Development" means research and research related activities performed for the purpose of developing new products and research </span><span style={{fontSize: '13pt'}}>activities performed by truGeny on the de-identified user data. Some of the activities could include improving our Services and or delivering new</span><span style={{fontSize: '13pt'}}>new products or services to you; data analysis activities and performing quality control activities.</span><span style={{fontSize: '13pt'}}>d. "Service" or "Services" means truGeny's products, software, services, and website (including but not limited to text, graphics, images, and</span><span style={{fontSize: '13pt'}}>other material and information) as accessed from time to time by the user, regardless if the use is in connection with an account or not.</span><span style={{fontSize: '13pt'}}>e. "Personal Information" is the information that can be used to identify you, either alone or in combination with other information. truGeny </span><span style={{fontSize: '13pt'}}>collects and stores the following types of Personal Information: </span><span style={{fontSize: '13pt'}}>a. "Registration Information" is the information you provide about yourself when registering for and/or purchasing our Services (e.g. name, email,</span><span style={{fontSize: '13pt'}}>address, user ID and password, and payment information).</span><span style={{fontSize: '13pt'}}>b. "Genetic Information" is information regarding your genotype (e.g. the As, Ts, Cs, and Gs at particular locations in your genome), generated </span><span style={{fontSize: '13pt'}}>through processing of your saliva by truGeny or by its contractors, successors, and assignees; or otherwise processed by and/or contributed to </span><span style={{fontSize: '13pt'}}>truGeny.</span><span style={{fontSize: '13pt'}}> c. "Self-Reported Information" is all information about yourself, including your disease conditions, other health-related information, personal traits,</span></p>
                          <p><span style={{fontSize: '13pt'}}>ethnicity, family history, and other information that you enter into surveys, forms, or features while signed in to your truGeny account. Self-</span><span style={{fontSize: '13pt'}}>Reported Information is included in truGeny Research only if it has been indicated for truGeny Research use on the website and if you have</span></p>
                          <p><span style={{fontSize: '13pt'}}>given consent according to the applicable Consent Document.</span><span style={{fontSize: '13pt'}}>d. "User Content" is all information, data, text, software, music, audio, photographs, graphics, video, messages, or other materials - other than </span><span style={{fontSize: '13pt'}}>Genetic Information and Self-Reported Information-generated by users of truGeny Services and transmitted, whether publicly or privately, to or </span><span style={{fontSize: '13pt'}}>through truGeny.</span><span style={{fontSize: '13pt'}}>e. "Web Behavior Information" is information on how you use the truGeny website (e.g. browser type, domains, page views) collected through</span><span style={{fontSize: '13pt'}}>log files, cookies, and web beacon technology.</span><span style={{fontSize: '13pt'}}>f. "Aggregated Genetic and Self-Reported Information" is Genetic and Self-Reported Information that has been combined with that of other users</span><span style={{fontSize: '13pt'}}>and analyzed or evaluated as a whole, such that no specific individual may be reasonably identified.</span></p>
                          <p />
                        </div>
                      </div>
                                            </Collapse>
                      
                    </div>
                    {/* --------------------------------------------------------------------------------- */}
                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h5 className="acc-header collapse-color mb-0" style={{color:this.state.q2?'#2C333C':'#4F5BE7'}}>
                          Acceptance of Terms
                          {this.state.b2?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle2} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle2} className="fa fa-minus-circle  rounded-circle " /></button>}
                        </h5>
                      </div>
                      <Collapse isOpen={this.state.q2}>
                      <div id="collapseTwo" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionIhc">
                        <div className="card-body">
                          <p style={{fontSize: '13pt'}}>
                            Your use of truGeny's Services (excluding any services provided by truGeny under a separate agreement) is subject to the terms of the legal agreement between you and truGeny set forth in these Terms of Service ("TOS"). Except as specified herein, these TOS apply to any use of the Services, including but not limited to a) submitting a saliva sample for DNA extraction and processing, b) uploading a digital version of your Genetic Information and interacting with it on the truGeny website, and/or c) creating and using a free truGeny account without providing your saliva sample or Genetic Information. In order to use the Services, you must first agree to the TOS. You may not use the Services if you do not accept the TOS. You can accept the TOS by (1) clicking to accept or agree to the TOS, where this option is made available to you by truGeny for any Service; or by (2) actually using the Services. In this case, you acknowledge and agree that truGeny will treat your use of the Services as acceptance of the TOS from that point onwards. In addition, when using particular truGeny Services, you shall be subject to any guidelines or rules applicable to such services that may be posted from time to time. All such guidelines or rules are hereby incorporated by reference into the TOS. truGeny also may offer other services from time to time that are governed by different terms of service.
                          </p>
                        </div>
                      </div>
                                            
                    </Collapse>
                      
                    </div>
                    {/* ------------------------------------------------3rd------------------------ */}
                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h5 className="acc-header collapse-color mb-0" style={{color:this.state.q3?'#2C333C':'#4F5BE7'}}>
                          Prerequisites
                          {this.state.b3?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle3} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle3} className="fa fa-minus-circle  rounded-circle " /></button>}
                        </h5>
                      </div>
                      <Collapse isOpen={this.state.q3}>
                      <div id="collapseThree" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionIhc">
                        <div className="card-body">
                          <p>
                            <span style={{fontSize: '13pt'}}>a. Whether you submit your own saliva sample, a saliva sample for anyone for whom you have legal authority to agree, or otherwise provide your</span>
                            <span style={{fontSize: '13pt'}}>own Genetic Information, you may not use the Services and may not accept the TOS if (1) you are not of legal age to form a binding contract with</span>
                            <span style={{fontSize: '13pt'}}>truGeny, or (2) you are a person barred from receiving the Services under the laws of the jurisdiction in which you are resident or from which you</span>
                            <span style={{fontSize: '13pt'}}>use the Services.</span>
                            <span style={{fontSize: '13pt'}}>b. In addition to the conditions above, if you contribute or otherwise provide your own Genetic Information, you must be eighteen (18) years of</span>
                            <span style={{fontSize: '13pt'}}>age or older to agree to these TOS on behalf of yourself or those for whom you have legal authority to agree.</span>
                            <span style={{fontSize: '13pt'}}>c. If your use of the Services includes creating a truGeny account, without submitting a saliva sample or otherwise providing Genetic</span>
                            <span style={{fontSize: '13pt'}}>Information, you must be thirteen (13) years of age or older to use the Services and accept the TOS.</span>
                          </p>
                        </div>
                      </div>
                                            
                    </Collapse>
                      
                    </div>
                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h5 className="acc-header collapse-color mb-0" style={{color:this.state.q4?'#2C333C':'#4F5BE7'}}>
                          Description of the Services
                            {this.state.b4?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle4} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle4} className="fa fa-minus-circle  rounded-circle " /></button>}
                            </h5>
                      </div>
                      <Collapse isOpen={this.state.q4}>
                      <div id="collapsefour" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionIhc">
                        <div className="card-body">
                          <p><span style={{fontSize: '13pt'}}>The Services include access to the truGeny public website and personal genotyping services, including the collection and analysis of your saliva </span><span style={{fontSize: '13pt'}}>sample. Unless explicitly stated otherwise, each new feature that augments or enhances the current Service shall be subject to the TOS. You </span><span style={{fontSize: '13pt'}}>acknowledge and agree that the Services are provided "AS-IS" and are based on the current state of the art of genetic research and technology</span> 
                            <span style={{fontSize: '13pt'}}>in use by truGeny at the time of the purchase or viewing. As research progresses and scientific knowledge and technology evolve, truGeny is
                            </span>
                            <span style={{fontSize: '13pt'}}>constantly innovating in order to provide the best possible experience for its users. You acknowledge and agree that the form and nature of the</span>
                            <span style={{fontSize: '13pt'}}>Services which truGeny provides may change from time to time without prior notice to you. As part of this continuing innovation, you </span>
                            <span style={{fontSize: '13pt'}}>acknowledge and agree that truGeny may stop (permanently or temporarily) providing some Services (or any features within the Services) to </span>
                            <span style={{fontSize: '13pt'}}>you or to users generally at truGeny's sole discretion, without prior notice to you. You may stop using the Services at any time. You do not need</span>
                            <span style={{fontSize: '13pt'}}>to specifically inform truGeny when you stop using the Services unless you are requesting closure of your account. truGeny assumes no </span>
                            <span style={{fontSize: '13pt'}}>responsibility for the use of Services outside the terms of this TOS or other applicable terms. In order to use the Services, you must obtain</span>
                            <span style={{fontSize: '13pt'}}>Internet access, either directly or through devices that access web-based content, and pay any service fees associated with such access. You </span>
                            <span style={{fontSize: '13pt'}}>are solely responsible for paying such fees. In addition, you must provide all equipment necessary to make such Internet connection, including a</span>
                            <span style={{fontSize: '13pt'}}>computer and modem or other access device. You are solely responsible for providing such equipment. You acknowledge and agree that</span>
                            <span style={{fontSize: '13pt'}}>while truGeny may not currently have set a fixed upper limit on the number of transmissions you may send or receive through the Services or on</span>
                            <span style={{fontSize: '13pt'}}>the amount of</span>
                          </p>
                        </div>
                      </div>
                                            
                    </Collapse>
                      
                    </div>
                    {/* -------------------------------------------------------------------------------------------------- */}
                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h5 className="acc-header collapse-color mb-0" style={{color:this.state.q5?'#2C333C':'#4F5BE7'}}>
                          Risks and Considerations Regarding truGeny Services
                        {this.state.b5?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle5} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle5} className="fa fa-minus-circle  rounded-circle " /></button>}
                        </h5>
                      </div>
                      <Collapse isOpen={this.state.q5}>
                      <div id="collapsefour1f" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionIhc">
                        <div className="card-body">
                          <p className=" roboto-reg-18px">
                            Once you obtain your Genetic Information, the knowledge is irrevocable. You should not assume that any information we may be able to provide
                            to you, whether now or as genetic research advances, will be welcome or positive. You should also understand that as research advances, in
                            order for you to assess the meaning of your DNA in the context of such advances, you may need to obtain further services from truGeny, your
                            physician, a genetic counsellor, or other health care provider.<br />

                            We encourage you to talk to a genetic counsellor, a health professional with special training in genetic conditions, prior to collecting your sample
                            for testing tolearn more so you can make an informed decision about whether testing is right for you. A genetic counsellor also can help you
                            understand your results and options. Some people feel a little anxious about getting genetic health results. This is normal. If you feel very
                            anxious, you should speak to your physician or a genetic counsellor prior to collecting your sample for testing.<br />
                            You may learn information about yourself that you do not anticipate. This information may evoke strong emotions and has the potential to alter
                            your life and worldview. You may discover things about yourself that trouble you and that you may not have the ability to control or change (e.g.,
                            you may have a higher than average chance of developing a specific condition or disease). These outcomes could have social, legal, or
                            economic implications.<br />
                            The laboratory may not be able to process your sample, and the laboratory process may result in errors. The laboratory may not be able to
                            process your sample up to 3.0% of the time if your saliva does not contain a sufficient volume of DNA, you do not provide enough saliva, or the
                            results from processing do not meet our standards for accuracy.* If the initial processing fails for any of these reasons, truGeny will reprocess
                            the same sample at no charge to the user. If the second attempt to process the same sample fails, truGeny will offer to send another kit to the
                            user to collect a second sample at no charge. If the user sends another sample and truGeny's attempts to process the second sample are
                            unsuccessful, truGeny will not send additional sample collection kits and the user will be entitled solely and exclusively to a complete refund of
                            the amount paid to truGeny, less shipping and handling, provided the user shall not resubmit another sample through a future purchase of the
                            service. If the user breaches this policy agreement and resubmits another sample through a future purchase of the service and processing is not
                            successful, truGeny will not offer to reprocess the sample or provide the user a refund. Even for processing that meets our high standards, a
                            small, unknown fraction of the data generated during the laboratory process may be un-interpretable or incorrect (referred to as "Errors"). As this
                            possibility is known in advance, users are not entitled to refunds where these Errors occur.<br />
                            You should not change your health behaviour solely on the basis of information from truGeny. Make sure to discuss your Genetic Information
                            with a physician or other health care provider before you act upon the Genetic Information resulting from truGeny Services. For most common
                            diseases, the genes we know about are only responsible for a small fraction of the risk. There may be unknown genes, environmental factors, or
                            lifestyle choices that are far more important predictors.<br />
                            If your data indicates that you are not at elevated genetic risk for a particular disease or condition, you should not feel that you are protected. The
                            opposite is also true; if your data indicates you are at an elevated genetic risk for a particular disease or condition, it does not mean you will
                            definitively develop the disease or condition. In either case, if you have concerns or questions about what you learn through truGeny, you should
                            contact your physician or other health care provider. Please note that genetic risk assessment is not applicable to results of carrier screening
                            tests.<br />
                            Genetic research is not comprehensive. While we measure many hundreds of thousands of data points from your DNA, only a small percentage
                            of them are known to be related to human traits or health conditions. The research community is rapidly learning more about genetics, and an
                            important mission of truGeny is to conduct and contribute to this research. In addition, many ethnic groups are not included in genetic studies.
                            Because interpretations provided in our service rely on these published studies, some interpretations may not apply to you. Future scientific
                            research may change the interpretation of your DNA. In the future, the scientific community may show previous research to be incomplete or
                            inaccurate.<br />
                            Genetic Information you share with others could be used against your interests. You should be careful about sharing your Genetic Information
                            with others. You may want to consult a lawyer to understand the extent of legal protection of your Genetic Information before you share it with
                            anybody.<br />
                            Furthermore, Genetic Information that you choose to share with your physician or other health care provider may become part of your medical
                            record. Genetic Information that you share with family, friends or employers may be used against your interests. Even if you share Genetic
                            Information that has no or limited meaning today, that information could have greater meaning in the future as new discoveries are made.
                            truGeny Services are for research, informational, and educational use only. We do not provide medical advice. The Genetic Information provided
                            by truGeny is for research, informational, and educational use only. This means two things. First, many of the genetic discoveries that we report
                            have not been clinically validated, and the technology we use, which is the same technology used by the research community, to date has not
                            been widely used for clinical testing.<br />
                            Second, in order to expand and accelerate the understanding and practical application of genetic knowledge in health care, we invite all users to
                            participate in truGeny Research. Participation in such research is voluntary and based upon an consent document. As a result of the current
                            state of genetic knowledge and understanding, our Services are for research, informational, and educational purposes only. The Services are not
                            intended to be used by the customer for any diagnostic purpose and are not a substitute for professional medical advice. You should always seek
                            the advice of your physician or other health care provider with any questions you may have regarding diagnosis, cure, treatment, mitigation, or
                            prevention of any disease or other medical condition or
                            impairment or the status of your health.<br />
                            truGeny does not endorse, warranty or guarantee the effectiveness of any specific course of action, resources, tests, physician or other health
                            care providers, drugs, biologics, medical devices or other products, procedures, opinions, or other information that may be mentioned on our
                            website. If we provide to you on our website any recommendations that identify for you, based on your Genetic and Self-Reported Information
                            and scientific literature or research, potentially actionable information, this information is intended for informational purposes only and for
                            discussion with your physician or other healthcare provider. As explained on our website, truGeny believes that (a) genetics is only part of the
                            picture of any individual's state of being, (b) the state of the understanding of Genetic Information is rapidly evolving and at any given time we
                            only comprehend part of the picture of the role of genetics, and (c) only a trained physician or other health care provider can assess your current
                            state of health or disease, taking into account many factors, including in some cases your genetics as well as your current symptoms, if any.
                            Reliance on any information provided by truGeny, truGeny employees, others appearing on our website at the invitation of <a href="/">
                              https://www.truGeny.com/</a>truGeny, or other visitors to our website is solely at your own risk.<br />
                           
                          </p>
                        </div>
                      </div>
                                            
                    </Collapse>
                      
                    </div>
                    {/* --------------------------------------------------------------------------------------------------- */}
                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h5 className="acc-header collapse-color mb-0" style={{color:this.state.q6?'#2C333C':'#4F5BE7'}}>
                          User Representations
                      {this.state.b6?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle6} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle6} className="fa fa-minus-circle  rounded-circle " /></button>}
                      </h5>
                      </div>
                      <Collapse isOpen={this.state.q6}>
                      <div id="collapsefour123" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionIhc">
                        <div className="card-body">
                          <p className=" roboto-reg-18px">
                            By accessing truGeny Services, you agree to, acknowledge, and represent as follows:<br /><br />
                            a. You understand that information you learn from truGeny is not designed to independently diagnose, prevent, or treat any condition or disease
                            or to ascertain the state of your health in the absence of medical and clinical information. You understand that the truGeny services are intended
                            for research, informational, and educational purposes only, and that while truGeny information might point to a diagnosis or to a possible
                            treatment, it should always be confirmed and supplemented by additional medical and clinical testing and information. You acknowledge that
                            truGeny urges you to seek the advice of your physician or other health care provider if you have questions or concerns arising from your Genetic
                            Information.<br />
                            b. You give permission to truGeny, its contractors, successors and assignees to perform genotyping services on the DNA extracted from your
                            saliva sample and you specifically request truGeny to disclose the results of analyses performed on your DNA to you and to others you
                            specifically authorize.<br />
                            c. You represent that you are eighteen (18) years of age or older if you are providing a saliva sample or accessing your Genetic Information.<br />
                            d. You are guaranteeing that any sample you provide is your saliva; if you are agreeing to these TOS on behalf of a person for whom you have
                            legal authorization, you are confirming that the sample provided will be the sample of that person.
                            e. You are warranting that you are not an insurance company or an employer attempting to obtain information about an insured person or an
                            employee.<br />
                            f. You are aware that some of the information you receive may provoke strong emotion.
                            <br />
                            g. You take responsibility for all possible consequences resulting from your sharing with others access to your Genetic Information and your Self-
                            Reported Information.
                            <br />
                            h. You understand that all your Personal Information will be stored in truGeny databases and will be processed in accordance with the truGeny
                            Privacy Statement <a href="/al_privacy_policy">(https://www.truGeny.com/about/privacy/).</a><br />
                            k. <b>Waiver of Property Rights:</b> You understand that by providing any sample, having your Genetic Information processed, accessing your
                            Genetic Information, or providing Self-Reported Information, you acquire no rights in any research or commercial products that may be
                            developed by truGeny or its collaborating partners. You specifically understand that you will not receive compensation for any research or
                            commercial products that include or result from your Genetic Information or Self-Reported Information.<br /><br />
                            You agree that you have the authority, under the laws of the state or jurisdiction in which you reside, to provide these representations. In case of
                            breach of any one of these representations truGeny has the right to suspend or terminate your account and refuse any and all current or future
                            use of the Services (or any portion thereof) and you will defend and indemnify truGeny and its affiliates against any liability, costs, or damages
                            arising out of the breach of the representation.<br />
                          </p>
                        </div>
                      </div>
                                            
                    </Collapse>

                    </div>
                    {/* ---------------------------------------------------------------------------------- */}
                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h5 className="acc-header collapse-color mb-0"  style={{color:this.state.q7?'#2C333C':'#4F5BE7'}}>
                          Account Creation, Customer Account, Password, and Security Obligations
                      {this.state.b7?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle7} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle7} className="fa fa-minus-circle  rounded-circle " /></button>}
                      </h5>
                      </div>
                      <Collapse isOpen={this.state.q7}>
                      <div id="collapsefour2" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionIhc">
                        <div className="card-body">
                          <p className=" roboto-reg-18px">
                            In consideration of your use of the Services, you agree to:<br /><br />
                            (a) provide true, accurate, current, and complete Registration Information about yourself as prompted by the Service; and (b) maintain and
                            promptly update the Registration Information to keep it true, accurate, current, and complete. If you provide any Registration Information that is
                            untrue, inaccurate, not current, or incomplete, or if truGeny has a reasonable ground to suspect that such information is untrue, inaccurate, not
                            current, or incomplete, truGeny has the right to suspend or terminate your account and refuse any and all current or future use of the Service (or
                            any portion thereof). The Services are for use only in the country to which your sample collection kit was shipped from truGeny.<br /><br />
                            After you have purchased our Service, you will create a password and account designation. You are responsible for maintaining the
                            confidentiality of the password and account, and are fully responsible for all activities that occur under your password or account. If you allow
                            third parties to access truGeny's website through your username and password, you will defend and indemnify truGeny and its affiliates against
                            any liability, costs, or damages, including attorney fees, arising out of claims or suits by such third parties based upon or relating to such access
                            and use. You agree to (a) immediately notify truGeny of any unauthorized use of your password or account or any other breach of security, and
                            (b) ensure that you exit from your account at the end of each session. truGeny cannot and will not be liable for any loss or damage arising from
                            your failure to comply with this Section.<br /><br />
                          </p>
                        </div>
                      </div>
                                            
                    </Collapse>

                    </div>
                    {/* ---------------------------------------------------------------------------------- */}
                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h5 className="acc-header collapse-color mb-0"  style={{color:this.state.q8?'#2C333C':'#4F5BE7'}}>
                          truGeny Privacy Statement and Disclosure of Information
                        {this.state.b8?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle8} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle8} className="fa fa-minus-circle  rounded-circle " /></button>}
                        </h5>
                      </div>
                      <Collapse isOpen={this.state.q8}>
                      <div id="collapsefour3" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionIhc">
                        <div className="card-body">
                          <p className=" roboto-reg-18px">
                            In order to use the Services, you must first acknowledge and agree to the Privacy Statement (<a href="/">https://www.truGeny.com/about/privacy/</a>). You may
                            not use the Services if you do not accept the Privacy Statement. You can acknowledge and agree to the Privacy Statement by (1) clicking to
                            accept or agree to the Privacy Statement, where this option is made available to you by truGeny for any Service; or by (2) actually using the
                            Services. You acknowledge and agree that truGeny has the right to monitor any use of its systems by its personnel at any time and maintain
                            copies documenting such monitoring. Our Privacy Statement sets forth the only expectations of privacy any individual should have in terms of
                            usage of the truGeny Services, website, or other systems. If you have given consent for your Genetic Information and Self-Reported Information
                            to be used in truGeny Research as described in the applicable Consent Document, we may include your information in the Aggregated Genetic
                            <br /><br />
                            Information and Self-Reported Information we disclose to third parties for the purpose of publication in a peer-reviewed scientific journal.
                            truGeny may also include your information in Aggregated Genetic and Self-Reported
                            Information disclosed to third-party non-profit and/or commercial research partners who will not publish that information in a peer-reviewed
                            scientific journal.<br /><br />
                            truGeny Research may be sponsored by, conducted on behalf of, or in collaboration with third parties, such as non-profit foundations, academic
                            institutions or pharmaceutical companies. truGeny Research may study a specific group or population, identify potential areas or targets for
                            therapeutics development, conduct or support the development of drugs, diagnostics or devices to diagnose, predict or treat medical or other
                            health conditions, work with public, private and/or non-profit entities on genetic research initiatives, or otherwise create, commercialize, and apply
                            this new knowledge to improve health care. truGeny will never release your individual-level Genetic Information and/or Self-Reported
                            Information to any third party without asking for and receiving your explicit consent
                            to do so, unless required by law.<br /><br />
                            Further, you acknowledge and agree that truGeny is free to preserve and disclose any and all Personal Information to law enforcement agencies
                            or others if required to do so by law or in the good faith belief that such preservation or disclosure is reasonably necessary to: (a) comply with
                            legal process (such as a judicial proceeding, court order, or government inquiry) or obligations that truGeny may owe pursuant to ethical and
                            other professional rules, laws, and regulations;
                            (b) enforce the truGeny TOS; (c) respond to claims that any content violates the rights of third parties; or (d) protect the rights, property, or
                            personal safety of<br /><br />
                            truGeny, its employees, its users, its clients, and the public. In such event we will notify you through the contact information you have provided to
                            us in advance, unless doing so would violate the law or a court order. You understand that the technical processing and transmission of the
                            Services, including your Personal Information, may involve (a) transmissions over various networks; and (b) changes to conform and adapt to
                            technical requirements of connecting networks, or devices. Finally, truGeny may, in its sole discretion, restrict access to the website for any
                            reason. Please refer to our Privacy Statement to read about data protection related to your information. See our complete Privacy Statement
                            (<a href="/">https://www.truGeny.com/about/privacy/</a>) here.<br /><br />
                          </p>
                        </div>
                      </div>
                                            
                    </Collapse>

                    </div>
                    {/* ---------------------------------------------------------------------------------- */}
                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h5 className="acc-header collapse-color mb-0" style={{color:this.state.q9?'#2C333C':'#4F5BE7'}}>
                          Limited License
                        {this.state.b9?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle9} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle9} className="fa fa-minus-circle  rounded-circle " /></button>}
                        </h5>
                      </div>
                      <Collapse isOpen={this.state.q9}>
                      <div id="collapsefour11" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionIhc">
                        <div className="card-body">
                          <p className=" roboto-reg-18px">
                            You acknowledge that all User Content, whether publicly posted or privately transmitted, is the sole responsibility of the person from which such
                            User Content originated. This means that you, and not truGeny, are entirely responsible for all User Content that you upload, post, email, or
                            otherwise transmit via the Service.<br /><br />
                            You acknowledge that the Services content presented to you as part of the Services, whether original truGeny Services content or sponsored
                            content within the Services, is protected by copyright and/or other intellectual property rights that are owned by truGeny and/or the sponsors
                            who provide that content to truGeny (or by other persons or companies on their behalf). truGeny grants you a Limited License to copy and
                            distribute free of charge, for non-commercial purposes only, any of the Services content with the exception of content from "MD's Perspectives" in
                            the "For the Experts" section of the website and any other content marked as not subject to this Limited License on the website, provided you: (i)
                            provide the Services content as it appears on the truGeny website with no changes including but not limited to presenting selections which might
                            tend to misrepresent the substance of the Services content; (ii) include the following attribution on the first page of any materials you distribute: ©
                            truGeny, Inc. 2007-2017. All rights reserved; distributed pursuant to a Limited License from truGeny; (iii) agree you have no right to offer anyone
                            else any further right with respect to this Services content. Aside from the Limited License provided in this paragraph, you may not modify, rent,
                            lease, loan, sell, distribute, or create derivative works based on this Services content (either in whole or in part) unless you
                            have been specifically told that you may do so by truGeny or by the owners of that content, in a separate agreement.<br /><br />
                          </p>
                        </div>
                      </div>
                                            
                    </Collapse>
                      
                    </div>
                    {/* ---------------------------------------------------------------------------------- */}
                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h5 className="acc-header collapse-color mb-0" style={{color:this.state.q10?'#2C333C':'#4F5BE7'}}>
                          Customer Conduct - Unlawful and Prohibited Use
                    {this.state.b10?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle10} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle10} className="fa fa-minus-circle  rounded-circle " /></button>}
                    </h5>
                      </div>
                      <Collapse isOpen={this.state.q10}>
                      <div id="collapsefour12" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionIhc">
                        <div className="card-body">
                          <p className=" roboto-reg-18px">
                            As a condition of your use of the Services, you warrant to truGeny that you will not use the Services for any purpose that is unlawful or
                            prohibited by these terms, conditions, or notices. You may not use the Services in any manner that could damage, disable, overburden, or impair
                            the Services or interfere with any other party's use and enjoyment of the Services. You may not obtain or attempt to obtain any materials or
                            information through any means not intentionally made available or provided for through the Services. You may not use the Services outside of the
                            country to which your sample collection kit was shipped from truGeny.<br /><br />
                            Furthermore you agree not to use the Services to: (1) upload, post, email, or otherwise transmit any material that is derogatory, defamatory,
                            obscene, or offensive, such as slurs, epithets, or anything that might reasonably be construed as harassment or disparagement based on race,
                            color, national origin, sex, sexual orientation, age, disability, religious or political beliefs, or other statutorily protected status; (2) impersonate any
                            person or entity, including, but not limited to, anyone affiliated with truGeny, or falsely state or otherwise misrepresent your affiliation with a
                            person or entity; (3) add your own headers, forge headers, or otherwise manipulate identifiers in order to disguise the origin of any content
                            transmitted through the Service; (4) "stalk" or otherwise harass another; (5) upload, post, email, or otherwise transmit any content that you do not
                            have a right to transmit under any law or under contractual or fiduciary relationships (such as inside information, proprietary and confidential
                            information learned or disclosed as part of employment relationships or under non disclosure agreements); (6) use any information received
                            through the Services to attempt to identify other customers, to contact other customers (other than through features for contacting other
                            users such as DNA Relatives offered pursuant to the Services), or for any forensic use; (7) download any file posted by another user of the
                            Service that you know, or reasonably should know, cannot legally be distributed in such manner; (8) upload, post, email or otherwise transmit any
                            content that infringes any patent, trademark, trade secret, copyright, or other proprietary rights ("Rights") of truGeny or any other party; (9) harm
                            minors in any way; (10) advertise or offer to sell or buy any goods or services for any business purpose, unless such area specifically allows such
                            messages; (11) upload, post, email, or otherwise transmit any unsolicited or unauthorized advertising, promotional materials, "junk mail," "spam,"
                            "chain letters," "pyramid schemes," or any other form of solicitation, except in those areas that are designated for such purpose and only to the
                            extent such content is authorized by law; (12) upload, post, email, or otherwise transmit any material that contains software viruses or any other
                            computer code, files, or programs designed to interrupt, destroy, or limit the functionality of any computer software or hardware or
                            telecommunications equipment; (13) use manual or automated software, devices, scripts robots, other means or processes to access,
                            "scrape," "crawl" or "spider" any web pages or other services contained in the site, unless explicitly permitted by truGeny; (14) engage in
                            "framing," "mirroring,"<br /><br />
                            or otherwise simulating the appearance or function of truGeny's website; (15) attempt to or actually override any security component of truGeny
                            web services; (16) interfere with or disrupt the Service or servers or networks connected to the Service, or disobey any requirements,
                            procedures, policies, or regulations of networks connected to the Service; (17) violate these Terms of Service, any code of conduct or other
                            guidelines which may be applicable for any particular area of the Service or have been communicated to you by anyone affiliated with truGeny;
                            or (18) intentionally or unintentionally violate any applicable local, state, national, or international law, or any regulations having the force of law.
                            You acknowledge and agree that you are solely responsible for (and that truGeny has no responsibility to you or to any third party for) any
                            breach of your obligations under the TOS and for the consequences (including any loss or damage which truGeny may suffer) of any such
                            breach. In case of breach of any one of these agreements truGeny has the right to suspend or terminate your account and refuse any and all
                            current or future use of the Services (or any portion thereof) and you will defend and indemnify truGeny and its affiliates against any liability,
                            costs, or damages arising out of the breach of the representation. If you violate the terms of this Section and/or truGeny has a reasonable
                            ground to suspect that you have violated the terms of this Section, truGeny has the right to suspend or terminate your account and refuse any
                            and all current or future use of the Service (or any portion thereof).<br /><br />
                          </p>
                        </div>
                      </div>
                                            
                    </Collapse>

                    </div>
                    {/* ---------------------------------------------------------------------------------- */}
                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h5 className="acc-header collapse-color mb-0" style={{color:this.state.q11?'#2C333C':'#4F5BE7'}}>
                          Export Control and Applicable Laws and Regulations
{this.state.b11?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle11} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle11} className="fa fa-minus-circle  rounded-circle " /></button>}
</h5>
                      </div>
                      <Collapse isOpen={this.state.q11}>
                      <div id="collapsefour21" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionIhc">
                        <div className="card-body">
                          <p className=" roboto-reg-18px">
                            Recognizing the global nature of the Internet, you agree to comply with all local rules regarding online conduct and acceptable content.
                            Specifically, you agree 1) that providing your sample is not subject to any export ban or restriction in the country in which you reside, 2) that your
                            sample and data may be transferred and/or processed outside the country in which you reside, and 3) that you will comply with all applicable
                            laws regarding the transmission of technical data exported from the United States or the country from which you access truGeny's Services
                            online.
                          </p>
                        </div>
                      </div>              
                    </Collapse>
                      
                    </div>
                    {/* ---------------------------------------------------------------------------------- */}
                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h5 className="acc-header collapse-color mb-0" style={{color:this.state.q12?'#2C333C':'#4F5BE7'}}>
                          Material Posted Through The Service
{this.state.b12?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle12} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle12} className="fa fa-minus-circle  rounded-circle " /></button>}
</h5>
                      </div>
                      <Collapse isOpen={this.state.q12}>
                      <div id="collapsefour22" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionIhc">
                        <div className="card-body">
                          <p className=" roboto-reg-18px">
                            truGeny will not, at all times, control any of the User Content posted via the Service and, as such, does not guarantee the accuracy, integrity, or
                            quality of such non-truGeny content. You understand that by using the Services, you may be exposed to content that is offensive, indecent, or
                            objectionable. circumstances will truGeny be liable in any way for any non-truGeny content, including, but not limited to, any errors or omissions
                            in any such content, or for any loss or damage of any kind incurred as a result of the use of any such content posted, emailed, or otherwise
                            transmitted via the Services.<br /><br />
                            You acknowledge that truGeny and its designees shall have the right (but not the obligation) in their sole discretion to pre-screen, review, filter,
                            modify, refuse, or move any content that is available via the Services. Without limiting the foregoing, truGeny and its designees shall have the
                            right to remove any content that violates the TOS or is deemed by truGeny, in its sole discretion, to be otherwise objectionable. You
                            acknowledge and agree that you must evaluate, and bear all risks associated with, the use of any content, including any reliance on the
                            accuracy, completeness, or usefulness of such content.<br /><br />
                          </p>
                        </div>
                      </div>
                                            
                    </Collapse>
                      
                    </div>
                    {/* ---------------------------------------------------------------------------------- */}
                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h5 className="acc-header collapse-color mb-0" style={{color:this.state.q13?'#2C333C':'#4F5BE7'}}>
                          Material Provided to truGeny - Your Proprietary Rights
{this.state.b13?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle13} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle13} className="fa fa-minus-circle  rounded-circle " /></button>}
</h5>
                      </div>
                      <Collapse isOpen={this.state.q13}>
                      <div id="collapsefour121" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionIhc">
                        <div className="card-body">
                          <p className=" roboto-reg-18px">
                            User Content. truGeny does not claim ownership of the User Content you provide to truGeny (including feedback and suggestions) or post,
                            upload, input, or submit to the Service. Unless otherwise specified, you retain copyright and any other rights you already hold over User Content
                            that you create and submit, post, or display on or through the Services. However, by submitting, posting, or displaying User Content, you give
                            truGeny, its affiliated companies, sublicensees (including but not limited to sublicensees who avail themselves of the Limited License granted in
                            Section 9 above) and successors and assigns a perpetual, irrevocable, worldwide, royalty-free, and non-exclusive license to reproduce, adapt,
                            modify, translate, publish, publicly perform, publicly display, distribute, reproduce, edit, reformat, and create derivative works from any User
                            Content that you submit, post, or display on or through the Services. You acknowledge and agree that this license includes a right for truGeny to
                            make such User Content available to other companies, organizations, or individuals with whom truGeny has relationships, and to use such User
                            Content in connection with the provision of those services.<br /><br />
                            You understand that truGeny, in performing the required technical steps to provide the Services to our users, may (a) transmit or distribute your
                            User Content over various public networks and in various media; and (b) make such changes to your content as are necessary to conform and
                            adapt that content to the technical requirements of connecting networks, devices, services, or media. You acknowledge and agree that this
                            license shall permit truGeny to take these actions. You represent and warrant to truGeny that you have all the rights, power, and authority
                            necessary to grant the above license.<br /><br />
                            Genetic and/or Self-Reported Information. Disclosure of individual-level Genetic and/or Self-Reported Information to third parties will not occur
                            without explicit consent, unless required by law. Note that truGeny cannot control any further distribution of Genetic and/or Self-Reported
                            Information that you share publicly on the truGeny website. You acknowledge and agree that you are responsible for protecting and enforcing
                            those rights and that truGeny has no obligation to do so on your behalf. Your saliva sample, once submitted to and analyzed by us, is processed
                            in an irreversible manner and cannot be returned to you. See our website for more information on sample processing. Any Genetic Information
                            derived from your saliva remains your information, subject to rights we retain as set forth in these TOS.
                            You understand that you should not expect any financial benefit from truGeny as a result of having your Genetic Information processed; made
                            <br /><br />
                            available to you; or, as provided in our Privacy Statement and Terms of Service, shared with or included in Aggregated Genetic and Self-
                            Reported Information shared with research partners, including commercial partners. Waiver of Property Rights. As stated above, you understand
                            <br /><br />
                            that by providing any sample, having your Genetic Information processed, accessing your Genetic Information, or providing Self-Reported
                            Information, you acquire no rights in any research or commercial products that may be developed by truGeny or its collaborating partners. You
                            specifically understand that you will not receive compensation for any research or commercial products that include or result from your
                            Genetic Information or Self-Reported Information.<br /><br />
                          </p>
                        </div>
                      </div>
                                            
                    </Collapse>

                    </div>
                    {/* ---------------------------------------------------------------------------------- */}
                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h5 className="acc-header collapse-color mb-0" style={{color:this.state.q14?'#2C333C':'#4F5BE7'}}>
                          Indemnity
{this.state.b14?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle14} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle14} className="fa fa-minus-circle  rounded-circle " /></button>}
</h5>
                      </div>
                      <Collapse isOpen={this.state.q14}>
                      <div id="collapsefour212" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionIhc">
                        <div className="card-body">
                          <p className=" roboto-reg-18px">
                            You agree to defend and hold truGeny, and its subsidiaries, affiliates, officers, agents, contractors, partners, employees, successors, and
                            assigns harmless from any claim, or demand, including reasonable attorneys' fees, made by any third party due to or arising out of User Content
                            you submit, post to, or transmit through the Service; your use of the Service; your connection to the Service; your violation of the TOS; or your
                            violation of any rights of another. If you have submitted a saliva sample or otherwise provided your own Genetic Information, you will defend and
                            hold harmless truGeny, its employees, contractors, successors, and assigns from any liability arising out of the use or disclosure of any
                            information obtained from genotyping your saliva sample and/or analyzing your Genetic Information, which is disclosed to you consistent with our
                            Privacy Statement or results from any third-party add-ons to tools we provide. In addition, if you choose to provide your Genetic and/or Self-
                            Reported Information to third parties - whether individuals to whom you facilitate access, intentionally or inadvertently, or to third parties for
                            diagnostic or other purposes - you agree to defend and hold harmless truGeny, its employees, contractors, successors, and assigns from any
                            and all liability arising from such disclosure or use of your Genetic and/or Self-Reported Information.
                          </p>
                        </div>
                      </div>
                                            
                    </Collapse>
                      
                    </div>
                    {/* ---------------------------------------------------------------------------------- */}
                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h5 className="acc-header collapse-color mb-0" style={{color:this.state.q15?'#2C333C':'#4F5BE7'}}>
                          No Resale of Service
{this.state.b15?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle15} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle15} className="fa fa-minus-circle  rounded-circle " /></button>}
</h5>
                      </div>
                      <Collapse isOpen={this.state.q15}>
                      <div id="collapsefour31" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionIhc">
                        <div className="card-body">
                          <p className=" roboto-reg-18px">
                            Other than pursuant to the terms of the Limited License in Section 9 of this TOS or unless otherwise agreed in a separate agreement between
                            you and truGeny, you agree not to display, distribute, license, perform, publish, reproduce, duplicate, copy, create derivative works from, modify,
                            sell, resell, exploit, transfer, or transmit for any commercial purposes, all or any portion of the Service, use of the Service, or access to the
                            Service.
                          </p>
                        </div>
                      </div>
                                            
                    </Collapse>
                      
                    </div>
                    {/* ---------------------------------------------------------------------------------- */}
                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h5 className="acc-header collapse-color mb-0" style={{color:this.state.q16?'#2C333C':'#4F5BE7'}}>
                          General Practices Regarding Use and Storage
{this.state.b16?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle16} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle16} className="fa fa-minus-circle  rounded-circle " /></button>}
</h5>
                      </div>
                      <Collapse isOpen={this.state.q16}>
                      <div id="collapsefour312" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionIhc">
                        <div className="card-body">
                          <a style={{color: '#000'}}>
                            <p className=" roboto-reg-18px">
                              You acknowledge that truGeny may establish general practices and limits concerning use of the Services, including without limitation the
                              maximum number of days that Personal Information and Services content will be retained by the Service, the maximum disk space that will be
                              allotted on truGeny's servers on your behalf, and the maximum number of times (and the maximum duration for which) you may access the
                              Services in a given period of time. You acknowledge and agree that truGeny has no responsibility or liability for the deletion of or failure to store
                              any messages, other communications, or other content maintained or transmitted by the Services; or for the loss of Genetic Information due to
                              malfunction or destruction of data servers or other catastrophic events. You further acknowledge that truGeny reserves the right to change these
                              general practices and limits in its sole discretion.
                            </p>
                          </a></div><a style={{color: '#000'}}>
                        </a></div>
                                            
                    </Collapse>
                      <a style={{color: '#000'}}>
                      </a></div><a style={{color: '#000'}}>
                      {/* ---------------------------------------------------------------------------------- */}
                      <div className="card">
                        <div className="card-header" id="headingTwo">
                          <h5 className="acc-header collapse-color mb-0" style={{color:this.state.q17?'#2C333C':'#4F5BE7'}}>
                            Modifications to Service
{this.state.b17?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle17} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle17} className="fa fa-minus-circle  rounded-circle " /></button>}
</h5>
                        </div>
                        <Collapse isOpen={this.state.q17}>
                        <div id="collapsefour5" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionIhc">
                          <div className="card-body">
                            <p className=" roboto-reg-18px">
                              truGeny reserves the right at any time and from time to time to modify or discontinue, temporarily or permanently, the Services (or any part
                              thereof) with or without notice. You acknowledge and agree that (i) modifications may result in a delay in computations for some of the truGeny
                              features or Services, and (ii) truGeny shall not be liable to you or to any third party for any modification, suspension, or discontinuance of the
                              Services. The Software that you use may from time to time automatically download and install updates from truGeny. These updates are
                              designed to improve, enhance, and further develop the Services and may take the form of bug fixes, enhanced functions, new software modules,
                              and completely new versions. You agree to receive such updates (and permit truGeny to deliver these to you) as part of your use of the
                              Services. You acknowledge that truGeny may offer different or additional technologies or features to collect and/or interpret Genetic Information
                              in the future and that your initial purchase of the Service does not entitle you to any different or additional technologies or features for collection
                              or interpretation of your Genetic Information without fee, and that you will have to pay additional fees in order to have your Genetic Information
                              collected, processed, and/or interpreted using any future or additional technologies or features.
                            </p>
                          </div>
                        </div>         
                    </Collapse>
                       
                      </div>
                      {/* ---------------------------------------------------------------------------------- */}
                      <div className="card">
                        <div className="card-header" id="headingTwo">
                          <h5 className="acc-header collapse-color mb-0" style={{color:this.state.q18?'#2C333C':'#4F5BE7'}}>
                            Termination
{this.state.b18?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle18} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle18} className="fa fa-minus-circle  rounded-circle " /></button>}
</h5>
                        </div>
                        <Collapse isOpen={this.state.q18}>
                        <div id="collapsefour6" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionIhc">
                          <div className="card-body">
                            <p className=" roboto-reg-18px">
                              The TOS will continue to apply until terminated by either you or truGeny as set out in this Section.
                              If you want to terminate your legal agreement with truGeny, you may do so by notifying truGeny at any time in writing, which will entail closing
                              your accounts for all of the Services that you use. Your notice should be sent, in writing, to truGeny's address, which is set out at the beginning
                              of the TOS, or online via Customer Care (<a href="/">https://customercare.truGeny.com</a>). If you provide notice online, truGeny will send you an email
                              asking you to confirm your request, and your notice will be effective following receipt of a second email confirmation from you.
                              truGeny may at any time, terminate its legal agreement with you (and in conjunction therewith, your password and account(s)) if: (1) you have
                              breached any provision of the TOS (or have acted in manner which shows that you do not intend to, or are unable to comply with, the provisions
                              of the TOS); (2) truGeny is required to do so by law (for example, where the provision of the Services to you is, or becomes, unlawful); (3) the
                              partner with whom truGeny offered the Services to you has terminated its relationship with truGeny or ceased to offer the Services to you; (4)
                              truGeny is transitioning to no longer providing the Services to users in the country or state in which you reside or from which you use the
                              Services; or (5) the provision of the Services to you by truGeny is, in truGeny's opinion, no longer commercially viable.
                              Any suspected fraudulent, abusive, or illegal activity that may be grounds for termination of your use of the Services may be referred to
                              appropriate law enforcement authorities. You acknowledge and agree that truGeny shall not be liable to you or any third party for any termination
                              of your access to the Services.
                            </p>
                          </div>
                        </div>            
                    </Collapse>
                        
                      </div>
                      {/* ---------------------------------------------------------------------------------- */}
                    </a><div className="card"><a style={{color: '#000'}}>
                        <div className="card-header" id="headingTwo">
                          <h5 className="acc-header collapse-color mb-0" style={{color:this.state.q19?'#2C333C':'#4F5BE7'}}>
                            Survival of Terms
{this.state.b19?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle19} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle19} className="fa fa-minus-circle  rounded-circle " /></button>}
</h5>
                        </div>
                      </a>
                      <Collapse isOpen={this.state.q19}>
                      <div id="collapsefour7" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionIhc"><a style={{color: '#000'}}>
                        </a><div className="card-body"><a style={{color: '#000'}}>
                          </a><a style={{color: '#000'}}>
                            <p className=" roboto-reg-18px">
                              When the TOS come to an end, all of the legal rights, obligations, and liabilities that you and truGeny have benefited from, been subject to (or
                              which have accrued over time while the TOS have been in force) or which are expressed to continue indefinitely, shall be unaffected by this
                              cessation, and the provisions of sections 1.(Definitions); 2.(Acceptance of Terms); 3.(Prerequisites); 4.(Description of the Services); 5.(Risks and
                              Considerations Regarding truGeny Services); 6. (User Representations); 7.(Account Creation, Customer Account, Password and Security
                              Obligations); 8.(truGeny Privacy Statement and Disclosure of Information); 10.(Customer Conduct - Unlawful and Prohibited Use); 11.(Export
                              Control and Applicable Laws and Regulations); 12.(Material Posted through the Service); 13.(Material Provided to truGeny - Your Proprietary
                              Rights); 14.(Indemnity); 15.(No Resale of Services); 18.(Termination); 19.(Survival of Terms); 20. (Dealings with Information Providers and Listed
                              Resources); 21.(Hyperlinks and truGeny Website); 22.(truGeny Proprietary Rights); 23.(DISCLAIMER OF
                              WARRANTIES); 24.(LIMITATION OF LIABILITY); 25.(Notice); 27.(Violation or Suspected Violation of Terms of Service); and 28.(Miscellaneous)
                              shall continue to apply to such rights, obligations, and liabilities indefinitely.
                            </p>
                          </a>
                        </div>
                      </div>
                                            
                    </Collapse>
                    
                    </div>
                    {/* ---------------------------------------------------------------------------------- */}
                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h5 className="acc-header collapse-color mb-0" style={{color:this.state.q20?'#2C333C':'#4F5BE7'}}>
                          Dealings with Information Providers and Listed Resources
{this.state.b20?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle20} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle20} className="fa fa-minus-circle  rounded-circle " /></button>}
</h5>
                      </div>
                      <Collapse isOpen={this.state.q20}>
                      <div id="collapsefour132" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionIhc">
                        <div className="card-body">
                          <p className=" roboto-reg-18px">
                            Your correspondence or business dealings with-or participation in promotions of-information providers, vendors, and/or resources found on or
                            through the Service, including payment and delivery of related goods or services, and any other terms, conditions, warranties, or representations
                            associated with such dealings, are solely between you and such information provider or resource. You acknowledge and agree that truGeny
                            shall not be responsible or liable for any loss or damage of any sort incurred as the result of any such dealings or as the result of the presence of
                            such information provider or resources on the Service.
                          </p>
                        </div>
                      </div>
                                            
                    </Collapse>
                     
                    </div>
                    {/* ---------------------------------------------------------------------------------- */}
                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h5 className="acc-header collapse-color mb-0" style={{color:this.state.q21?'#2C333C':'#4F5BE7'}}>
                          Hyperlinks and the truGeny Website
{this.state.b21?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle21} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle21} className="fa fa-minus-circle  rounded-circle " /></button>}
</h5>
                      </div>
                      <Collapse isOpen={this.state.q21}>
                      <div id="collapsefour0" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionIhc">
                        <div className="card-body">
                          <p className=" roboto-reg-18px">
                            The Service provides, and third parties may provide, links to other sites and resources on the Internet. Because truGeny has no control over
                            such sites and resources, you acknowledge and agree that truGeny is not responsible for the availability of such external sites or resources, and
                            does not endorse and is not responsible or liable for any content, advertising, products, or other materials on or available from such sites or
                            resources. You further acknowledge and agree that truGeny shall not be responsible or liable, directly or indirectly, for any damage or loss
                            caused or alleged to be caused by or in connection with use of or reliance on any such content, goods, or services available on or through any
                            such hyperlinked site or resource.
                          </p>
                        </div>
                      </div>
                                            
                    </Collapse>
                      
                    </div>
                    {/* ---------------------------------------------------------------------------------- */}
                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h5 className="acc-header collapse-color mb-0" style={{color:this.state.q22?'#2C333C':'#4F5BE7'}}>
                          truGeny's Proprietary Rights
{this.state.b22?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle22} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle22} className="fa fa-minus-circle  rounded-circle " /></button>}
</h5>
                      </div>
                      <Collapse isOpen={this.state.q22}>
                      <div id="collapsefour9" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionIhc">
                        <div className="card-body">
                          <p className=" roboto-reg-18px">
                            You acknowledge and agree that truGeny (or truGeny's licensors, as applicable) own all legal right, title, and interest in and to the Services,
                            including any intellectual property rights (including but not limited to patents) which subsist in the Services (whether those rights happen to be
                            registered or not, and wherever in the world those rights may exist). You further acknowledge that the Services may contain information which is
                            designated confidential by truGeny and that you shall not disclose such information without truGeny's prior written consent.<br /><br />
                            You further acknowledge and agree that the Services and any necessary software used in connection with the Services ("Software") contain
                            proprietary and confidential information that is protected by applicable intellectual property and other laws. You further acknowledge and agree
                            that information presented to you through the Services or sponsors is protected by copyrights, trademarks, service marks, patents, or other
                            proprietary rights and laws. Except as expressly authorized by truGeny, you agree not to-and not to permit anyone else to-modify, rent, lease,
                            loan, sell, distribute, or create derivative works of, reverse engineer, decompile, or otherwise attempt to extract the source code of the Services or
                            Software or any part thereof, in whole or in part. Software, if any, that is made available to download from the Services, excluding software that
                            may be made available by end-users through the Services, is the copyrighted work of truGeny and/or its suppliers. Your use of the Software is
                            governed by the terms of the end user license agreement, if any, which accompanies or is included with the Software ("License Agreement"). You
                            may not install or use any Software that is accompanied by or includes a License Agreement unless you first agree to the
                            License Agreement terms. truGeny, Inc., truGeny, and other truGeny logos and product and service names are trademarks of truGeny and
                            these marks together with any other
                            truGeny trade names, service marks, logos, domain names, and other distinctive brand features are the "truGeny Marks". Unless you have
                            agreed otherwise in writing with truGeny, other than through the Limited License in Section 9, nothing in the TOS gives you a right to use any
                            truGeny Marks and you agree not to display, or use in any manner, truGeny Marks.<br /><br />
                            You agree that you shall not remove, obscure, or alter any proprietary rights notices (including copyright and trade mark notices) that may be
                            affixed to or contained within the Services. Unless you have been expressly authorized to do so in writing by truGeny, you agree that in using
                            the Services, you will not use any trade mark, service mark, trade name logo of any company or organization in a way that is likely or intended to
                            cause confusion about the owner or authorized user of such marks names, trade name, logo of any company or organization in a way that is
                            likely or intended to cause confusion about the owner or authorized user of such marks, names, or logos.
                            For any Software not accompanied by a License Agreement, truGeny grants you a personal, non-transferable, and non-exclusive right and
                            license to use the object code of its Software on a single computer. You may not (and may not allow any third party to) copy, modify, create a
                            derivative work of, reverse engineer, reverse assemble, or otherwise attempt to discover any source code, sell, assign, sublicense, grant a
                            security interest in, or otherwise transfer any right in the Software unless this is expressly permitted or required by law, or unless you have been
                            specifically told that you may do so by truGeny, in writing. This license is
                            for the sole purpose of enabling you to use and enjoy the benefit of the Services as provided by truGeny, in the manner permitted by the TOS.
                            Unless truGeny has given you specific written permission to do so, you may not assign (or grant a sublicense of) your rights to use the Software,
                            grant a security interest in or over your rights to use the Software, or otherwise transfer any part of your rights to use the Software. You agree not
                            to modify the Software in any manner or form, or to use modified versions of the Software, including (without limitation) for the purpose of
                            obtaining unauthorized access to the Service. You agree not to access the Service by any means other than through the interface that is provided
                            by truGeny for use in accessing the Service. Any rights not expressly granted herein are reserved.
                          </p>
                        </div>
                      </div>
                                            
                    </Collapse>

                    </div>
                    {/* ---------------------------------------------------------------------------------- */}
                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h5 className="acc-header collapse-color mb-0" style={{color:this.state.q23?'#2C333C':'#4F5BE7'}}>
                          Disclaimer of Warranties
{this.state.b23?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle23} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle23} className="fa fa-minus-circle  rounded-circle " /></button>}
</h5>
                      </div>
                      <Collapse isOpen={this.state.q23}>
                      <div id="collapsefour86" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionIhc">
                        <div className="card-body">
                          <p className=" roboto-reg-18px">
                            YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT: (1) YOUR USE OF THE SERVICES ARE AT YOUR SOLE RISK. THE SERVICES ARE
                            PROVIDED ON AN "AS IS” AND "AS AVAILABLE" BASIS. truGeny EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER
                            EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
                            PARTICULAR PURPOSE, AND NON-INFRINGEMENT. (2) truGeny MAKES NO WARRANTY THAT (a) THE SERVICES WILL MEET YOUR
                            REQUIREMENTS; (b) THE SERVICES WILL BE UNINTERRUPTED, TIMELY, UNFAILINGLY SECURE, OR ERRORFREE;
                            (c) THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE SERVICES WILL BE ACCURATE OR RELIABLE; (d) THE QUALITY
                            OF ANY PRODUCTS, SERVICES, INFORMATION, OR OTHER MATERIAL PURCHASED OR OBTAINED BY YOU THROUGH THE SERVICES
                            WILL MEET YOUR EXPECTATIONS AND (e) ANY ERRORS IN THE SOFTWARE WILL BE CORRECTED. (3) ANY MATERIAL DOWNLOADED
                            OR OTHERWISE OBTAINED THROUGH THE USE OF THE SERVICES IS DONE AT YOUR OWN DISCRETION AND RISK AND THAT YOU
                            WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR COMPUTER SYSTEM OR LOSS OF
                            DATA THAT RESULTS FROM THE DOWNLOAD OF ANY SUCH MATERIAL. (4) NO ADVICE OR INFORMATION, WHETHER ORAL OR
                            WRITTEN, OBTAINED BY YOU FROM truGeny OR THROUGH OR FROM THE SERVICES SHALL CREATE ANY WARRANTY NOT
                            EXPRESSLY STATED IN THE TOS. (5) YOU SHOULD ALWAYS USE CAUTION WHEN GIVING OUT ANY PERSONALLY IDENTIFYING
                            INFORMATION ABOUT YOURSELF OR THOSE FOR WHOM YOU HAVE LEGAL AUTHORITY. truGeny DOES NOT CONTROL OR
                            ENDORSE ANY ACTIONS RESULTING FROM YOUR PARTICIPATION IN THE SERVICES AND, THEREFORE, truGeny
                            SPECIFICALLY DISCLAIMS ANY LIABILITY WITH REGARD TO ANY ACTIONS RESULTING FROM YOUR PARTICIPATION IN THE
                            SERVICES.
                          </p>
                        </div>
                      </div>
                                            
                    </Collapse>
                      
                    </div>
                    {/* ---------------------------------------------------------------------------------- */}
                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h5 className="acc-header collapse-color mb-0" style={{color:this.state.q24?'#2C333C':'#4F5BE7'}}>
                          Limitation of Liability
{this.state.b24?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle24} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle24} className="fa fa-minus-circle  rounded-circle " /></button>}
</h5>
                      </div>
                      <Collapse isOpen={this.state.q24}>
                      <div id="collapsefour75" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionIhc">
                        <div className="card-body">
                          <p className=" roboto-reg-18px">
                          Within The Limits Allowed By Applicable Laws, You Expressly Acknowledge And Agree That Trugeny Shall Not Be
                            Liable For Any Direct, Indirect, Incidental, Special, Consequential, Or Exemplary Damages, Including But Not
                            Limited To, Damages For Loss Of Profits, Goodwill, Use, Data Or Other Intangible Losses (Even If Trugeny Has
                            Been Advised Of The Possibility Of Such Damages), Resulting From: (A) The Use Or The Inability To Use The
                            Services; (B) Any Action You Take Based On The Information You Receive In Through Or From
                            The Services, (V) Your Failure To Keep Your Password Or Account Details Secure And Confidential, (D) The Cost
                            Of Procurement Of Substitute Goods And Services Resulting From Any Goods, Data, Information, Or Services
                            Purchased Or Obtained Or Messages Received Or Transactions Entered Into Through Or From The Services; (E)
                            Unauthorized Access To Or Alteration Of Your Transmissions Or Data; (F) The Improper Authorization For The
                            Services By Someone Claiming Such Authority; Or (G) Statements Or
                            Conduct Of Any Third Party On The Services.
                          </p>
                        </div>
                      </div>
                                            
                    </Collapse>
                     
                    </div>
                    {/* ---------------------------------------------------------------------------------- */}
                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h5 className="acc-header collapse-color mb-0" style={{color:this.state.q25?'#2C333C':'#4F5BE7'}}>
                          Notice
{this.state.b25?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle25} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle25} className="fa fa-minus-circle  rounded-circle " /></button>}
</h5>
                      </div>
                      <Collapse isOpen={this.state.q25}>
                      <div id="collapsefour6a5" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionIhc">
                        <div className="card-body">
                          <p className=" roboto-reg-18px">
                            Notices to you may be made via either email or regular mail. truGeny may also provide notices of changes to the TOS or other matters by
                            displaying notices or links to notices to you generally on or through the Services. Official notices related to this TOS must be sent to us at:
                            truGeny, Inc.
                            ATTN:<br /><br />
                            truGeny<br /><br />
                            Additionally, truGeny accepts service of process at this address. Any notices that you provide without compliance with this section on Notices
                            shall have no legal
                            effect.
                          </p>
                        </div>
                      </div>
                                            
                    </Collapse>
                      
                    </div>
                    {/* ---------------------------------------------------------------------------------- */}
                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h5 className="acc-header collapse-color mb-0" style={{color:this.state.q28?'#2C333C':'#4F5BE7'}}>
                          Changes to the Terms of Service
{this.state.b28?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle28} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle28} className="fa fa-minus-circle  rounded-circle " /></button>}
</h5>
                      </div>
                      <Collapse isOpen={this.state.q28}>
                      <div id="collapsefour5" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionIhc">
                        <div className="card-body">
                          <a style={{color: '#000'}}>
                            <p className=" roboto-reg-18px">
                              truGeny may make changes to the TOS from time to time. When these changes are made, truGeny will make a new copy of the TOS available
                              on its website and any new additional terms will be made available to you from within, or through, the affected Services. You acknowledge and
                              agree that if you use the Services after the date on which the TOS have changed, truGeny will treat your use as acceptance of the updated TOS.
                            </p>
                          </a>
                        </div>
                      </div>
                                            
                    </Collapse>
                      
                    </div>
                    {/* ---------------------------------------------------------------------------------- */}
                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h5 className="acc-header collapse-color mb-0" style={{color:this.state.q26?'#2C333C':'#4F5BE7'}}>
                          Violation or Suspected Violation of Terms of Service
{this.state.b26?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle26} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle26} className="fa fa-minus-circle  rounded-circle " /></button>}
</h5>
                      </div>
                      <Collapse isOpen={this.state.q26}>
                      <div id="collapsetwofive4" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionIhc">
                        <div className="card-body">
                          {/* <a style="color:#000"> */}
                          <p className=" roboto-reg-18px">
                            If you violate the terms of these TOS and/or truGeny has a reasonable ground to suspect that you have violated the terms of these TOS,
                            truGeny has the right to suspend or terminate your account and refuse any and all current or future use of the Services (or any portion thereof).
                          </p>
                        </div>
                      </div>
                                            
                    </Collapse>
                    
                    </div>
                    {/* ---------------------------------------------------------------------------------- */}
                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h5 className="acc-header collapse-color mb-0" style={{color:this.state.q27?'#2C333C':'#4F5BE7'}}>
                          Miscellaneous
{this.state.b27?<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle27} className="fa fa-plus-circle  rounded-circle " /></button>:<button type="button" className="float-right btn btn-link rounded-circle" data-toggle="collapse" data-target="#collapseOne"><i onClick={this.toggle27} className="fa fa-minus-circle  rounded-circle " /></button>}
</h5>
                      </div>
                      <Collapse isOpen={this.state.q27}>
                      <div id="collapsetwosix54f" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionIhc">
                        <div className="card-body">
                          {/* <a style="color:#000"> */}
                          <p className=" roboto-reg-18px">
                            a. Entire Agreement. The TOS constitute the entire agreement between you and truGeny and govern your use of the Services, superseding any
                            prior agreements between you and truGeny on this subject. You also may be subject to additional terms and conditions that may apply when you
                            use affiliate services, third-party content, or third-party software
                            <br />b. Applicable law and arbitration. Except for any disputes relating to intellectual property rights, obligations, or any infringement claims, any
                            disputes with truGeny arising out of or relating to the Agreement ("Disputes") shall be governed by California law regardless of your country of
                            origin or where you access truGeny, and not with standing of any conflicts of law principles and the United Nations Convention for the
                            International Sale of Goods. Any Disputes shall be resolved by final and binding arbitration under the rules and auspices of the American
                            Arbitration Association, to be held in San Francisco, California, in English, with a written decision stating legal reasoning issued by the
                            arbitrator(s) at either party's request, and with arbitration costs and reasonable
                            documented attorneys' costs of both parties to be borne by the party that ultimately loses. Either party may obtain injunctive relief (preliminary or
                            permanent) and orders to compel arbitration or enforce arbitral awards in any court of competent jurisdiction.
                            <br />c. Waiver. The failure of truGeny to exercise or enforce any right or provision of the TOS shall not constitute a waiver of such right or provision. If
                            any provision of the TOS is found by a court of competent jurisdiction to be invalid, the parties nevertheless agree that the court should endeavor
                            to give effect to the parties' intentions as reflected in the provision, and the other provisions of the TOS remain in full force and effect.
                            <br />d. Term for cause of action. You agree that regardless of any statute or law to the contrary, any claim or cause of action arising out of or related to
                            use of the Services or the TOS must be filed within one (1) year after such claim or cause of action arose or be forever barred.
                            <br />e. Admissibility of printed version. A printed version of this agreement and of any notice given in electronic form shall be admissible in judicial or
                            administrative proceedings based upon or relating to this agreement to the same extent and subject to the same conditions as other business
                            documents and records originally generated and maintained in printed form.
                            <br />f. Section titles. The section titles in the TOS are for convenience only and have no legal or contractual effect.
                            <br />g. Severability Clause. If any portion of these TOS is found to be unenforceable, the remaining portion will remain in full force and effect.
                            <br />h. Amendments. We reserve the right to modify, supplement or replace the terms of the Agreement, effective upon posting at <a href="/">www.truGeny.com </a>
                                  notifying you otherwise. If you do not want to agree to changes to the Agreement, you can terminate the
                            Agreement at any time per Section 18 (Termination).<br />
                            i. Assignment: You may not assign or delegate any rights or obligations under the Agreement. Any purported assignment and delegation shall be
                            ineffective. We may freely assign or delegate all rights and obligations under the Agreement, fully or partially without notice to you. We may also
                            substitute, by way of unilateral novation, effective upon notice to you, truGeny for any third party that assumes our rights and obligations under
                            this Agreement.<br />
                            *truGeny data on file.
                          </p>
                          {/* </a> */}
                        </div>
                      </div>
                                            
                    </Collapse>

                    </div>
                  </div>
                </div>
                {/* eo bs-example */}
                {/* end of accordian code */}
              </div>
            </div>
            {/* eo card-block */}
          </div>
          {/* eo card body */}
          {/* eo card */}
          {/* eo-heart-accordian-sec-wrap */}
        </section>
        {/* eo-heart-accordian-sec */}
        {/* **********Schedule your Genetic Counseling Session Ends Here************** */}
        {/* Footer Links */}
       <SubFooter></SubFooter>
        {/* end of footer */}
        <div className="modal fade bd-example-modal-lg" id="exampleModalCenter" tabIndex={-1} role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div className="modal-content" style={{borderRadius: '40px'}}>
              <div className="modal-header bg-blue clearfix border-0" style={{borderTopRightRadius: '40px', borderTopLeftRadius: '40px'}}>
                <h5 className="modal-title" id="exampleModalLongTitle" style={{paddingTop: '5px', paddingBottom: '25px', color: '#2c333c', fontSize: '30px', fontWeight: 700}}>
                  Start your journey in 3 easy steps</h5>
                <button type="button" className="text-center close" data-dismiss="modal" aria-label="Close" style={{paddingTop: '25px', paddingBottom: '25px'}}>
                  <img className="img-fluid" src=".\img\registration\X.png" />
                </button>
                {/* <p class="float-left">Question 1 of 3</p> */}
              </div>
              <div className="bg-blue border-bottom-1">
                <p className="pl-3">Question 1 of 3</p>
              </div>
              <div className="modal-body pb-5 pt-0 m-0">
                <div className="container ">
                  <br />
                  <div className="tab-content">
                    <div id="home" className="container tab-pane active">
                      <br />
                      <h3>How do you indentify your gender?</h3>
                      <hr />
                      <div className="d-flex d-flex-inline">
                        <img className="mr-3" src="./img/q&a/female.png" alt="" />
                        <img className="mr-3" src="./img/q&a/female.png" alt="" />
                      </div>
                      <div className="float-right pt-2 mt-2">
                        <button type="button" className="btn btn-outline-primary text-center custom-button btn btn-outline-primary btn-hover-white my-2 my-sm-0" data-toggle="pill" href="#menu1">Next</button>
                      </div>
                    </div>
                    <div id="menu1" className=" m-0 p-0 container tab-pane fade">
                      <br />
                      <h3>Does anyone in your family have 2 diabetes?</h3>
                      <hr />
                      <h4>Certain ethnic groups have higher risk for diabetes,<br />
                        even at lower body weights.</h4>
                      <div className="col-xs-12 mt-2 ">
                        <div className="input-group-prepend " style={{border: 'solid 1px #ebebeb', maxWidth: '312px'}}>
                          <input type="text" placeholder="Select your ethnicity" className="form-control roboto-reg-16px" style={{border: 'none', height: '60px'}} aria-label="Text input with dropdown button" />
                          <button className="m-0 p-0 btn btn-outline-secondary roboto-bold-14px " href="#" style={{border: 'none', backgroundColor: 'white'}} type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><img className="m-0 p-0" src="img/q&a/carot.png" /></button>
                        </div>
                      </div>
                      <div className="float-right pt-2 mt-2">
                        <button type="button" className="btn btn-outline-primary text-center custom-button btn btn-outline-primary btn-hover-white my-2 my-sm-0" data-toggle="pill" href="#menu2">Next</button>
                      </div>
                    </div>
                    <div id="menu2" className=" m-0 p-0 container tab-pane fade">
                      <br />
                      <h3>Does anyone in your family have 2 diabetes?</h3>
                      <hr />
                      <div className="radio">
                        <label>
                          <input type="radio" name="optradio" defaultChecked /> Parents</label>
                      </div>
                      <div className="radio">
                        <label>
                          <input type="radio" name="optradio" /> Siblings</label>
                      </div>
                      <div className="float-right pt-2 mt-2">
                        <button type="button" className="btn btn-outline-primary text-center custom-button btn btn-outline-primary btn-hover-white my-2 my-sm-0" data-toggle="pill"  href="#">Submit</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* sticky form---------------- */}
        
            </div>
          </div>
        </div>
        {/* sticky form---------------- */}
        <div className="row ">
          <div className="nb-form">
            {/* <p class="title d-none d-lg-block ">May I Help You</p> */}
            <img src="https://www.growyourbrand.com/wp-content/uploads/2018/11/chat.gif" alt="" className="user-icon img-fluid" />
            <form>
              <input type="text" name="cpname" placeholder="Name:" required />
              <input type="email" name="cpemail" placeholder="Email:" required />
              <input type="tel" name="cpphone" placeholder="Phone:" required />
              <textarea name="cpmessage" placeholder="Message:" required defaultValue={""} />
              <input type="submit" defaultValue="Send message" style={{background: '#4f5be7'}} />
            </form>
          </div>
        </div>
        {/* search */}
        {/* eo saerch */}
        {/* --------eo sticky form----------------- */}
        {/* Optional JavaScript */}
        {/* jQuery first, then Popper.js, then Bootstrap JS */}
      </div>
       )
   }

}
export default AllTermsOfServices;